webpackJsonp([15],{

/***/ "+HcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__ = __webpack_require__("vued");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.Widget.Tabs
    *
    * Encapsulates the common functionality of the Tabs Widget.
    * Accessible tabs that offer keyboard navigation with manual activation with spacebar and/or enter keys
    * follows aria practices for accessibility from https://www.w3.org/TR/wai-aria-practices/#tabpanel
**/

HSN.Widget.Tabs = function () {
    var application = void 0;
    var container = void 0;
    var tabList = void 0;
    var tabs = void 0;
    var panels = void 0;
    var keys = void 0;
    var arrowKeyDirections = void 0;
    var focusTimeout = void 0;

    /**
        * new HSN.Widget.Tabs.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.Tabs]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
    **/
    function init(config) {
        application = config.application;
        container = $(config.container);

        //select tab elements based off of role schematics
        tabList = container.find('[role="tablist"]');
        tabs = container.find('[role="tab"]');
        panels = container.find('[role="tabpanel"]');

        //use a11y helper to get keyboard keys and directions to use in events
        keys = __WEBPACK_IMPORTED_MODULE_1_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
        bindEvents();
    }

    function bindEvents() {

        tabs.on('click', function (event) {
            var tab = $(event.target);
            activateTab(tab, false);
        });

        tabs.on('keydown', function () {
            return keydownEventListener(event);
        });
        tabs.on('keyup', function () {
            return keyupEventListener(event);
        });
        tabList.on('keydown', function () {
            return tabListEventListener(event);
        });
    }

    function tabListEventListener(event) {
        var key = event.keyCode;
        if (key === keys.spacebar || key === keys.enter) {
            event.preventDefault();
            $(tabs[0]).focus();
        } else if (key !== keys.tab) {
            event.preventDefault();
        }
    }

    function keydownEventListener(event) {
        var key = event.keyCode;
        event.preventDefault();
        switch (key) {
            case keys.end:
                // Activate last tab
                $(tabs[tabs.length - 1]).focus();
                break;
            case keys.home:
                // Activate first tab
                $(tabs[0]).focus();
                break;
            case keys.up:
            case keys.down:
                switchTabOnArrowPress(event);
                break;
        }

        return false;
    }

    function keyupEventListener(event) {
        var key = event.keyCode;

        switch (key) {
            case keys.left:
            case keys.right:
                switchTabOnArrowPress(event);
                break;
            case keys.tab:
                unfocusActiveTab(event);
                break;
            case keys.spacebar:
            case keys.enter:
                focusActiveTab(event);
        };

        return false;
    }

    function activateTab(tab, setFocus) {
        setFocus = setFocus || true;
        deactivateTabs();
        tab.removeAttr('tabindex');
        tab.attr('aria-selected', true);

        var controlElementId = '#' + tab.attr('aria-controls');
        $(controlElementId).removeAttr('hidden');

        if (setFocus) {
            tab.focus();
        }

        application.Events.Trigger(__WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__["a" /* default */].Widget.Tabs.SHOW, tab);
    }

    function deactivateTabs() {
        tabs.each(function (index) {
            __WEBPACK_IMPORTED_MODULE_1_HSNDIR_AccessibilityUtility_js__["a" /* default */].SetTabIndexProgrammatic($(this));

            $(this).attr('aria-selected', false);
            $(this).blur();
        });

        panels.each(function (index) {
            $(this).attr('hidden', 'hidden');
        });
    }

    function switchTabOnArrowPress(event) {
        var key = event.keyCode;
        var target = $(event.target);

        if (key === keys.left || key === keys.up) {
            target.prev().focus();
        }

        if (key === keys.right || key === keys.down) {
            target.next().focus();
        }
    }

    function focusActiveTab(event) {
        var target = $(event.currentTarget);
        focusTimeout = setTimeout(checkTabFocus, 1, target);
    }

    function unfocusActiveTab(event) {
        var target = $(event.target);
        target.blur();
    }

    function checkTabFocus(target) {
        var focused = $(document.activeElement);

        if (target.is(focused)) {
            activateTab(target, false);
            clearTimeout(focusTimeout);
            focusTimeout = null;
        };
    }

    function destroy() {
        tabs.off('click', function (event) {});
        tabs.off('keydown', function () {
            return keydownEventListener(event);
        });
        tabs.off('keyup', function () {
            return keyupEventListener(event);
        });

        application = container = tabs = focusTimeout = null;
    }

    return {
        init: init,
        destroy: destroy
    };
};

/***/ }),

/***/ "/Vzc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Widget_Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Widget_Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_HSNDIR_Widget_Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Widget_Tabs_js__ = __webpack_require__("+HcJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Events_js__ = __webpack_require__("vued");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;





/**
    * class HSN.Template.Bag
    *
    * Encapsulates the functionality the Communication Brands page.
    **/
var brandSelections = [];
var emailPrefSelections = [];
var mobilePrefSelections = [];
var currentCategorySelected = '';
var currentBrandNameSelected = '';
var currentBrandModalPage = 1;

HSN.Template.CommPrefBrands = function (config) {
    /**
        * new HSN.Template.Bag(config)
        * - config (Object): A configuration object for the [[HSN.Template.OrderHistory]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the template should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the template.
        **/

    var __scope = this;

    this._application = config.application;
    this._container = $(config.container);
    this.eventCoordinator = this._application.Events;

    this._application.Events.On(HSN.Modal.EVENT.MODAL_CLOSE, function () {
        brandSelections = [];
        HSN.Instance().GetBrandsEditModal().Hide();
        return;
    });

    this._application.Events.On(HSN.Modal.EVENT.MODAL_CLOSE, function () {
        brandSelections = [];
        HSN.Instance().GetBrandsEditModal().Hide();
        return;
    });

    this.eventCoordinator.On(__WEBPACK_IMPORTED_MODULE_3_HSNDIR_Events_js__["a" /* default */].Widget.Tabs.SHOW, function (element) {
        __scope.PopulateBrands(element.data('catid'), element.data('catname'));
    }, 'Tabs');

    $('#template-brands-all-tab').on('click', function (e) {
        $("#template-brands-all").addClass("active");
        $('#template-brands-selected-container').parent().removeClass("active");
        return false;
    });

    $('#all-brands-form :input:not(#select_all)').on('change', function (e) {
        if ($(this).is(':checked')) {

            if ($(this).attr('originalvalue') == "True") {
                var value = $(this).val();
                for (var currentObj = 0; currentObj < brandSelections.length; currentObj++) {
                    if (brandSelections[currentObj].value === value) {
                        brandSelections.splice(currentObj, 1);
                    }
                }
            } else {
                brandSelections.push({ 'name': 'SelectedBrands', 'value': $(this).val() });
            }
        } else {
            if ($(this).attr('originalvalue') == "True") {
                brandSelections.push({ 'name': 'UnselectedBrands', 'value': $(this).val() });
            } else {
                var value = $(this).val();

                for (var currentObj = 0; currentObj < brandSelections.length; currentObj++) {
                    if (brandSelections[currentObj].value === value) {
                        brandSelections.splice(currentObj, 1);
                    }
                }
            }
        }
    });

    $('#select_all').on('change', function () {
        $('#preferences-brands-save-button').removeClass('animated-save-btn');
        $('#preferences-brands-save-button').css('display', 'inline-block');
        if (this.checked) {
            $('.brand-item').each(function () {
                this.checked = true;
                $(this).trigger('change');
            });
        } else {
            $('.brand-item').each(function () {
                this.checked = false;
                $(this).trigger('change');
            });
        }
    });

    $('.brand-item').on('click', function () {
        $('#preferences-brands-save-button').css('display', 'inline-block');
        $('#preferences-brands-save-button').removeClass('animated-save-btn');
        if ($('.brand-item:checked').length === $('.brand-item').length) {
            $('#select_all').prop('checked', true);
        } else {
            $('#select_all').prop('checked', false);
        }
    });

    $('.category-list').on('click', function (e) {
        $(".category-list").removeClass("category-list-active");
        $(this).addClass("category-list-active");
    });
};
HSN.Template.CommPrefBrands.prototype = {
    BrandPagePrevious: function BrandPagePrevious() {

        var container = $("#all-brands-container");

        var currentPage = container.data("currentpage");
        if (currentPage > 1) {
            var nextPage = currentPage - 1;
            container.data("currentpage", nextPage);
            $("#all-brands-currentpage").val(nextPage);

            var pageSize = container.data("pagesize");
            var totalItems = container.data("totalitems");

            var showStartIndex = (nextPage - 1) * pageSize;
            var showEndIndex = showStartIndex + pageSize - 1;
            if (showEndIndex > totalItems - 1) showEndIndex = totalItems - 1;

            container.find("ul").hide();
            if (showEndIndex == showStartIndex) container.find("ul").slice(showStartIndex).show("fast");else container.find("ul").slice(showStartIndex, showEndIndex + 1).show("fast");
        }
    },

    BrandPageNext: function BrandPageNext() {
        var container = $("#all-brands-container");

        var currentPage = container.data("currentpage");
        var totalPages = container.data("totalpages");
        if (currentPage < totalPages) {
            var nextPage = currentPage + 1;
            container.data("currentpage", nextPage);
            $("#all-brands-currentpage").val(nextPage);

            var pageSize = container.data("pagesize");
            var totalItems = container.data("totalitems");

            var showStartIndex = currentPage * pageSize;
            var showEndIndex = showStartIndex + pageSize - 1;
            if (showEndIndex > totalItems - 1) showEndIndex = totalItems - 1;

            container.find("ul").hide();
            if (showEndIndex == showStartIndex) container.find("ul").slice(showStartIndex).show("fast");else container.find("ul").slice(showStartIndex, showEndIndex + 1).show("fast");
        }
    },

    BrandPageSelect: function BrandPageSelect(page) {

        var container = $("#all-brands-container");
        var currentPage = container.data("currentpage");

        if (page != currentPage) {

            var selectedPage = Number(page);

            container.data("currentpage", selectedPage);
            $("#all-brands-currentpage").val(selectedPage);

            var pageSize = container.data("pagesize");
            var totalItems = container.data("totalitems");

            var showStartIndex = (selectedPage - 1) * pageSize;
            var showEndIndex = showStartIndex + pageSize - 1;
            if (showEndIndex > totalItems - 1) showEndIndex = totalItems - 1;

            container.find("ul").hide();
            if (showEndIndex == showStartIndex) container.find("ul").slice(showStartIndex).show("fast");else container.find("ul").slice(showStartIndex, showEndIndex + 1).show("fast");
        }
    },

    BindEmailPreferences: function BindEmailPreferences() {
        $('.email-pref-item').on('change', function (e) {
            if ($(this).is(':checked')) {

                if ($(this).attr('originalvalue') == "selected") {
                    var value = $(this).val();

                    $.each(emailPrefSelections, function (i) {
                        if (this.value === value) emailPrefSelections.splice(i, 1);
                    });
                } else {
                    emailPrefSelections.push({ 'name': 'SelectedEmailPref', 'value': $(this).val() });
                }
            } else {
                if ($(this).attr('originalvalue') == "selected") {
                    emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $(this).val() });
                } else {

                    var value = $(this).val();
                    $.each(emailPrefSelections, function (i) {
                        if (this.value == value) emailPrefSelections.splice(i, 1);
                    });
                }
            }
        });
    },
    BindMobilePreferences: function BindMobilePreferences() {
        $('.text-pref-item').on('change', function (e) {
            if ($(this).is(':checked')) {

                if ($(this).attr('originalvalue') == "selected") {
                    var value = $(this).val();

                    $.each(mobilePrefSelections, function (i) {
                        if (this.value === value) mobilePrefSelections.splice(i, 1);
                    });
                } else {
                    mobilePrefSelections.push({ 'name': 'SelectedMobilePref', 'value': $(this).val() });
                }
            } else {
                if ($(this).attr('originalvalue') == "selected") {
                    mobilePrefSelections.push({ 'name': 'UnselectedMobilePref', 'value': $(this).val() });
                } else {

                    var value = $(this).val();

                    $.each(mobilePrefSelections, function (i) {
                        if (this.value == value) mobilePrefSelections.splice(i, 1);
                    });
                }
            }
        });
    },

    PopulateBrands: function PopulateBrands(categoryId, categoryName, isReload) {
        var scope = this;
        currentCategorySelected = categoryId;
        currentBrandNameSelected = categoryName;
        currentBrandModalPage = $('#all-brands-currentpage').val();

        $.ajax("/myaccount/compref/brands/get-by-category?catid=" + categoryId + "&catname=" + encodeURIComponent(categoryName), {
            context: this,
            dataType: 'html',
            success: function success(data, status, xhr) {
                $('#brand-list').html(data);
                if (isReload && currentBrandModalPage) {
                    scope.BrandPageSelect(currentBrandModalPage);
                }
            }
        });
    },

    CancelBrands: function CancelBrands() {

        var sAllBrandsTab = $("#template-brands-all").hasClass("active");

        if (sAllBrandsTab) {

            var selectedCat = $('#template-brands-all .category-list-active').data('catid');

            if (selectedCat != null) {

                $.ajax("/myaccount/compref/brands/get-by-category?catid=" + selectedCat, {
                    context: this,
                    dataType: 'html',
                    success: function success(data, status, xhr) {
                        $('#brand-list').html(data);
                    }
                });
            }
        } else {

            $.ajax("/myaccount/compref/brands/get-selected?_ts" + new Date().getTime(), {
                context: this,
                dataType: 'html',
                success: function success(data, status, xhr) {
                    $('#template-brands-selected-container').html(data);
                }
            });
        }
    },

    SaveBrands: function SaveBrands() {
        var me = this;
        var accountService = HSN.Instance()._getAccountService();

        //Have to do our own custom "serialization" here because unchecked boxes arent serialized by default, ugh...
        var serializedValues = [];
        serializedValues = brandSelections;
        var emailId = $('#all-brands-email-id').val();

        serializedValues.push({ 'name': 'EmailId', 'value': emailId });
        serializedValues.push({ 'name': 'Source', 'value': 'AllBrands' });

        if ($('#all-brands-form #select_all').is(':checked')) {
            serializedValues.push({ 'name': 'CategoryId', 'value': $('#all-brands-form #select_all').val() });
        } else {
            serializedValues.push({ 'name': 'UnSelectedCategoryId', 'value': $('#all-brands-form #select_all').val() });
        }

        if (emailId != undefined) {
            accountService.SaveBrandChanges(serializedValues, {
                callback: function callback(data) {
                    if (data.success) {
                        brandSelections.length = 0;

                        $('#preferences-brands-save-button').removeClass().addClass('animated-save-btn button');
                        me.PopulateBrands(currentCategorySelected, currentBrandNameSelected, true);
                    } else {
                        alert('There was a problem saving your changes.');
                    }
                }
            });
        }
    },

    SaveSelCatBrands: function SaveSelCatBrands() {
        $('.brand-item').each(function (e) {

            var brandItemVal = $(this).val();

            $.each(brandSelections, function (i) {
                if (this.value == brandItemVal) {
                    $('input[value=' + brandItemVal + ']').prop("checked", true);
                }
            });
        });
    },

    ShowOrHideContent: function ShowOrHideContent(obj, container, toggleindex) {
        HSN.AnimateAccordion(container, toggleindex, false, false, null);
    },

    SaveEmailPreferences: function SaveEmailPreferences(redirectUrl) {
        var accountService = HSN.Instance()._getAccountService();
        var email = $('#comm-pref-email').val();

        if (email != '') {
            emailPrefSelections.push({ 'name': 'Email', 'value': email });
            var promoEmails = false;
            if (emailPrefSelections.length > 0 && emailPrefSelections.some(function (data) {
                return data.name === "SelectedEmailPref" && data.value === "3";
            })) {
                promoEmails = true;
            }
            accountService.SaveEmailPreferenceChanges(emailPrefSelections, {

                callback: function callback(data) {
                    if (data.success) {
                        if (promoEmails) {
                            dataLayer.push({ 'signup_email': email });
                            HSN.DataLayer.helpers.hsnEvent(null, "EmailPromoSignupCommPrefs", "Success", null, null);
                        }
                        emailPrefSelections = [];
                        HSN.Template.CommPrefBrands.prototype.UpdateEmailOptionSelections();
                        $("#pref-save-applied").removeClass("applied-img-hidden").addClass("applied-img");
                    } else {
                        alert('There was a problem saving your email preferences.');
                    }
                }
            });
        }
    },

    SaveEmailSubscribe: function SaveEmailSubscribe() {
        var accountService = HSN.Instance()._getAccountService();
        var email = $('#comm-pref-email').val();

        if (email != '') {
            emailPrefSelections.push({ 'name': 'Email', 'value': email });

            //unsubscribe all
            if ($("#email-pref-item_unsubscribeall").prop('checked')) {

                emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $("#wtw-email-pref-unsubscribe").val() });
                $('#wtw-email-pref-unsubscribe').prop("checked", true);

                $('.email-pref-item-unsubscribe').each(function (e) {
                    emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $(this).val() });
                    $('.email-pref-item-unsubscribe').prop("checked", true);
                });

                var modal = HSN.Instance().GetEmailSurveyModal();
                modal.Show("/myaccount/compref/email-survey/modal/get/" + email);
            } else {

                //wtw subscribe / unsubscribe
                if ($("#wtw-email-pref-subscribe").prop('checked')) {
                    emailPrefSelections.push({ 'name': 'SelectedEmailPref', 'value': $("#wtw-email-pref-subscribe").val() });
                }

                if ($("#wtw-email-pref-unsubscribe").prop('checked')) {
                    emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $("#wtw-email-pref-unsubscribe").val() });
                }

                //email preferences subscribe / unsubscribe
                $('.email-pref-item-subscribe').each(function (e) {

                    if ($(this).prop('checked')) {
                        emailPrefSelections.push({ 'name': 'SelectedEmailPref', 'value': $(this).val() });
                    }
                });

                $('.email-pref-item-unsubscribe').each(function (e) {
                    if ($(this).prop('checked')) {
                        emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $(this).val() });
                    }
                });
            }

            accountService.SaveEmailPreferenceChanges(emailPrefSelections, {
                callback: function callback(data) {
                    if (data.success) {
                        emailPrefSelections = [];

                        $("#pref-save-applied").removeClass("applied-img-hidden").addClass("applied-img");
                    } else {
                        alert('There was a problem saving your email preferences.');
                    }
                }
            });
        }
    },

    SavePreferences: function SavePreferences() {
        $("#pref-save-applied").removeClass("applied-img").addClass("applied-img-hidden");
        this.SaveEmailPreferences();
    },

    SaveSubscribe: function SaveSubscribe() {
        $("#pref-save-applied").removeClass("applied-img").addClass("applied-img-hidden");
        this.SaveEmailSubscribe();
    },

    UpdateEmailOptionSelections: function UpdateEmailOptionSelections() {
        $('.email-pref-item').each(function (e) {
            if ($(this).is(':checked')) {
                $(this).attr('originalvalue', 'selected');
            } else {
                $(this).attr('originalvalue', 'unselected');
            }
        });
    }
};

/***/ }),

/***/ "3wK4":
/***/ (function(module, exports) {

/**
 * History.js jQuery Adapter
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <https://creativecommons.org/licenses/BSD/>
 */

// Closure
(function (window, undefined) {
    "use strict";

    // Localise Globals
    var
        History = window.History = window.History || {},
        jQuery = window.jQuery;

    // Check Existence
    if (typeof History.Adapter !== 'undefined') {
        throw new Error('History.js Adapter has already been loaded...');
    }

    // Add the Adapter
    History.Adapter = {
        /**
         * History.Adapter.bind(el,event,callback)
         * @param {Element|string} el
         * @param {string} event - custom and standard events
         * @param {function} callback
         * @return {void}
         */
        bind: function (el, event, callback) {
            jQuery(el).on(event, callback);
        },

        /**
         * History.Adapter.trigger(el,event)
         * @param {Element|string} el
         * @param {string} event - custom and standard events
         * @param {Object=} extra - a object of extra event data (optional)
         * @return {void}
         */
        trigger: function (el, event, extra) {
            jQuery(el).trigger(event, extra);
        },

        /**
         * History.Adapter.extractEventData(key,event,extra)
         * @param {string} key - key for the event data to extract
         * @param {string} event - custom and standard events
         * @param {Object=} extra - a object of extra event data (optional)
         * @return {mixed}
         */
        extractEventData: function (key, event, extra) {
            // jQuery Native then jQuery Custom
            var result = (event && event.originalEvent && event.originalEvent[key]) || (extra && extra[key]) || undefined;

            // Return
            return result;
        },

        /**
         * History.Adapter.onDomLoad(callback)
         * @param {function} callback
         * @return {void}
         */
        onDomLoad: function (callback) {
            jQuery(callback);
        }
    };

    // Try and Initialise History
    if (typeof History.init !== 'undefined') {
        History.init();
    }

})(window);

/**
 * History.js HTML4 Support
 * Depends on the HTML5 Support
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <https://creativecommons.org/licenses/BSD/>
 */

(function (window, undefined) {
    "use strict";

    // ========================================================================
    // Initialise

    // Localise Globals
    var
        document = window.document, // Make sure we are using the correct document
        setTimeout = window.setTimeout || setTimeout,
        clearTimeout = window.clearTimeout || clearTimeout,
        setInterval = window.setInterval || setInterval,
        History = window.History = window.History || {}; // Public History Object

    // Check Existence
    if (typeof History.initHtml4 !== 'undefined') {
        throw new Error('History.js HTML4 Support has already been loaded...');
    }


    // ========================================================================
    // Initialise HTML4 Support

    // Initialise HTML4 Support
    History.initHtml4 = function () {
        // Initialise
        if (typeof History.initHtml4.initialized !== 'undefined') {
            // Already Loaded
            return false;
        }
        else {
            History.initHtml4.initialized = true;
        }


        // ====================================================================
        // Properties

        /**
         * History.enabled
         * Is History enabled?
         */
        History.enabled = true;


        // ====================================================================
        // Hash Storage

        /**
         * History.savedHashes
         * Store the hashes in an array
         */
        History.savedHashes = [];

        /**
         * History.isLastHash(newHash)
         * Checks if the hash is the last hash
         * @param {string} newHash
         * @return {boolean} true
         */
        History.isLastHash = function (newHash) {
            // Prepare
            var oldHash = History.getHashByIndex(),
                isLast;

            // Check
            isLast = newHash === oldHash;

            // Return isLast
            return isLast;
        };

        /**
         * History.isHashEqual(newHash, oldHash)
         * Checks to see if two hashes are functionally equal
         * @param {string} newHash
         * @param {string} oldHash
         * @return {boolean} true
         */
        History.isHashEqual = function (newHash, oldHash) {
            newHash = encodeURIComponent(newHash).replace(/%25/g, "%");
            oldHash = encodeURIComponent(oldHash).replace(/%25/g, "%");
            return newHash === oldHash;
        };

        /**
         * History.saveHash(newHash)
         * Push a Hash
         * @param {string} newHash
         * @return {boolean} true
         */
        History.saveHash = function (newHash) {
            // Check Hash
            if (History.isLastHash(newHash)) {
                return false;
            }

            // Push the Hash
            History.savedHashes.push(newHash);

            // Return true
            return true;
        };

        /**
         * History.getHashByIndex()
         * Gets a hash by the index
         * @param {integer} index
         * @return {string}
         */
        History.getHashByIndex = function (index) {
            // Prepare
            var hash = null;

            // Handle
            if (typeof index === 'undefined') {
                // Get the last inserted
                hash = History.savedHashes[History.savedHashes.length - 1];
            }
            else if (index < 0) {
                // Get from the end
                hash = History.savedHashes[History.savedHashes.length + index];
            }
            else {
                // Get from the beginning
                hash = History.savedHashes[index];
            }

            // Return hash
            return hash;
        };


        // ====================================================================
        // Discarded States

        /**
         * History.discardedHashes
         * A hashed array of discarded hashes
         */
        History.discardedHashes = {};

        /**
         * History.discardedStates
         * A hashed array of discarded states
         */
        History.discardedStates = {};

        /**
         * History.discardState(State)
         * Discards the state by ignoring it through History
         * @param {object} State
         * @return {true}
         */
        History.discardState = function (discardedState, forwardState, backState) {
            //History.debug('History.discardState', arguments);
            // Prepare
            var discardedStateHash = History.getHashByState(discardedState),
                discardObject;

            // Create Discard Object
            discardObject = {
                'discardedState': discardedState,
                'backState': backState,
                'forwardState': forwardState
            };

            // Add to DiscardedStates
            History.discardedStates[discardedStateHash] = discardObject;

            // Return true
            return true;
        };

        /**
         * History.discardHash(hash)
         * Discards the hash by ignoring it through History
         * @param {string} hash
         * @return {true}
         */
        History.discardHash = function (discardedHash, forwardState, backState) {
            //History.debug('History.discardState', arguments);
            // Create Discard Object
            var discardObject = {
                'discardedHash': discardedHash,
                'backState': backState,
                'forwardState': forwardState
            };

            // Add to discardedHash
            History.discardedHashes[discardedHash] = discardObject;

            // Return true
            return true;
        };

        /**
         * History.discardedState(State)
         * Checks to see if the state is discarded
         * @param {object} State
         * @return {bool}
         */
        History.discardedState = function (State) {
            // Prepare
            var StateHash = History.getHashByState(State),
                discarded;

            // Check
            discarded = History.discardedStates[StateHash] || false;

            // Return true
            return discarded;
        };

        /**
         * History.discardedHash(hash)
         * Checks to see if the state is discarded
         * @param {string} State
         * @return {bool}
         */
        History.discardedHash = function (hash) {
            // Check
            var discarded = History.discardedHashes[hash] || false;

            // Return true
            return discarded;
        };

        /**
         * History.recycleState(State)
         * Allows a discarded state to be used again
         * @param {object} data
         * @param {string} title
         * @param {string} url
         * @return {true}
         */
        History.recycleState = function (State) {
            //History.debug('History.recycleState', arguments);
            // Prepare
            var StateHash = History.getHashByState(State);

            // Remove from DiscardedStates
            if (History.discardedState(State)) {
                delete History.discardedStates[StateHash];
            }

            // Return true
            return true;
        };


        // ====================================================================
        // HTML4 HashChange Support

        if (History.emulated.hashChange) {
            /*
             * We must emulate the HTML4 HashChange Support by manually checking for hash changes
             */

            /**
             * History.hashChangeInit()
             * Init the HashChange Emulation
             */
            History.hashChangeInit = function () {
                // Define our Checker Function
                History.checkerFunction = null;

                // Define some variables that will help in our checker function
                var lastDocumentHash = '',
                    iframeId, iframe,
                    lastIframeHash, checkerRunning,
                    startedWithHash = Boolean(History.getHash());

                // Handle depending on the browser
                if (History.isInternetExplorer()) {
                    // IE6 and IE7
                    // We need to use an iframe to emulate the back and forward buttons

                    // Create iFrame
                    iframeId = 'historyjs-iframe';
                    iframe = document.createElement('iframe');

                    // Adjust iFarme
                    // IE 6 requires iframe to have a src on HTTPS pages, otherwise it will throw a
                    // "This page contains both secure and nonsecure items" warning.
                    iframe.setAttribute('id', iframeId);
                    iframe.setAttribute('src', '#');
                    iframe.style.display = 'none';

                    // Append iFrame
                    document.body.appendChild(iframe);

                    // Create initial history entry
                    iframe.contentWindow.document.open();
                    iframe.contentWindow.document.close();

                    // Define some variables that will help in our checker function
                    lastIframeHash = '';
                    checkerRunning = false;

                    // Define the checker function
                    History.checkerFunction = function () {
                        // Check Running
                        if (checkerRunning) {
                            return false;
                        }

                        // Update Running
                        checkerRunning = true;

                        // Fetch
                        var
                            documentHash = History.getHash(),
                            iframeHash = History.getHash(iframe.contentWindow.document);

                        // The Document Hash has changed (application caused)
                        if (documentHash !== lastDocumentHash) {
                            // Equalise
                            lastDocumentHash = documentHash;

                            // Create a history entry in the iframe
                            if (iframeHash !== documentHash) {
                                //History.debug('hashchange.checker: iframe hash change', 'documentHash (new):', documentHash, 'iframeHash (old):', iframeHash);

                                // Equalise
                                lastIframeHash = iframeHash = documentHash;

                                // Create History Entry
                                iframe.contentWindow.document.open();
                                iframe.contentWindow.document.close();

                                // Update the iframe's hash
                                iframe.contentWindow.document.location.hash = History.escapeHash(documentHash);
                            }

                            // Trigger Hashchange Event
                            History.Adapter.trigger(window, 'hashchange');
                        }

                            // The iFrame Hash has changed (back button caused)
                        else if (iframeHash !== lastIframeHash) {
                            //History.debug('hashchange.checker: iframe hash out of sync', 'iframeHash (new):', iframeHash, 'documentHash (old):', documentHash);

                            // Equalise
                            lastIframeHash = iframeHash;

                            // If there is no iframe hash that means we're at the original
                            // iframe state.
                            // And if there was a hash on the original request, the original
                            // iframe state was replaced instantly, so skip this state and take
                            // the user back to where they came from.
                            if (startedWithHash && iframeHash === '') {
                                History.back();
                            }
                            else {
                                // Update the Hash
                                History.setHash(iframeHash, false);
                            }
                        }

                        // Reset Running
                        checkerRunning = false;

                        // Return true
                        return true;
                    };
                }
                else {
                    // We are not IE
                    // Firefox 1 or 2, Opera

                    // Define the checker function
                    History.checkerFunction = function () {
                        // Prepare
                        var documentHash = History.getHash() || '';

                        // The Document Hash has changed (application caused)
                        if (documentHash !== lastDocumentHash) {
                            // Equalise
                            lastDocumentHash = documentHash;

                            // Trigger Hashchange Event
                            History.Adapter.trigger(window, 'hashchange');
                        }

                        // Return true
                        return true;
                    };
                }

                // Apply the checker function
                History.intervalList.push(setInterval(History.checkerFunction, History.options.hashChangeInterval));

                // Done
                return true;
            }; // History.hashChangeInit

            // Bind hashChangeInit
            History.Adapter.onDomLoad(History.hashChangeInit);

        } // History.emulated.hashChange


        // ====================================================================
        // HTML5 State Support

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /*
             * We must emulate the HTML5 State Management by using HTML4 HashChange
             */

            /**
             * History.onHashChange(event)
             * Trigger HTML5's window.onpopstate via HTML4 HashChange Support
             */
            History.onHashChange = function (event) {
                //History.debug('History.onHashChange', arguments);

                // Prepare
                var currentUrl = ((event && event.newURL) || History.getLocationHref()),
                    currentHash = History.getHashByUrl(currentUrl),
                    currentState = null,
                    currentStateHash = null,
                    currentStateHashExits = null,
                    discardObject;

                // Check if we are the same state
                if (History.isLastHash(currentHash)) {
                    // There has been no change (just the page's hash has finally propagated)
                    //History.debug('History.onHashChange: no change');
                    History.busy(false);
                    return false;
                }

                // Reset the double check
                History.doubleCheckComplete();

                // Store our location for use in detecting back/forward direction
                History.saveHash(currentHash);

                // Expand Hash
                if (currentHash && History.isTraditionalAnchor(currentHash)) {
                    //History.debug('History.onHashChange: traditional anchor', currentHash);
                    // Traditional Anchor Hash
                    History.Adapter.trigger(window, 'anchorchange');
                    History.busy(false);
                    return false;
                }

                // Create State
                currentState = History.extractState(History.getFullUrl(currentHash || History.getLocationHref()), true);

                // Check if we are the same state
                if (History.isLastSavedState(currentState)) {
                    //History.debug('History.onHashChange: no change');
                    // There has been no change (just the page's hash has finally propagated)
                    History.busy(false);
                    return false;
                }

                // Create the state Hash
                currentStateHash = History.getHashByState(currentState);

                // Check if we are DiscardedState
                discardObject = History.discardedState(currentState);
                if (discardObject) {
                    // Ignore this state as it has been discarded and go back to the state before it
                    if (History.getHashByIndex(-2) === History.getHashByState(discardObject.forwardState)) {
                        // We are going backwards
                        //History.debug('History.onHashChange: go backwards');
                        History.back(false);
                    } else {
                        // We are going forwards
                        //History.debug('History.onHashChange: go forwards');
                        History.forward(false);
                    }
                    return false;
                }

                // Push the new HTML5 State
                //History.debug('History.onHashChange: success hashchange');
                History.pushState(currentState.data, currentState.title, encodeURI(currentState.url), false);

                // End onHashChange closure
                return true;
            };
            History.Adapter.bind(window, 'hashchange', History.onHashChange);

            /**
             * History.pushState(data,title,url)
             * Add a new State to the history object, become it, and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.pushState = function (data, title, url, queue) {
                //History.debug('History.pushState: called', arguments);

                // We assume that the URL passed in is URI-encoded, but this makes
                // sure that it's fully URI encoded; any '%'s that are encoded are
                // converted back into '%'s
                url = encodeURI(url).replace(/%25/g, "%");

                // Check the State
                if (History.getHashByUrl(url)) {
                    throw new Error('History.js does not support states with fragment-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.pushState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.pushState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy
                History.busy(true);

                // Fetch the State Object
                var newState = History.createStateObject(data, title, url),
                    newStateHash = History.getHashByState(newState),
                    oldState = History.getState(false),
                    oldStateHash = History.getHashByState(oldState),
                    html4Hash = History.getHash(),
                    wasExpected = History.expectedStateId == newState.id;

                // Store the newState
                History.storeState(newState);
                History.expectedStateId = newState.id;

                // Recycle the State
                History.recycleState(newState);

                // Force update of the title
                History.setTitle(newState);

                // Check if we are the same State
                if (newStateHash === oldStateHash) {
                    //History.debug('History.pushState: no change', newStateHash);
                    History.busy(false);
                    return false;
                }

                // Update HTML5 State
                History.saveState(newState);

                // Fire HTML5 Event
                if (!wasExpected)
                    History.Adapter.trigger(window, 'statechange');

                // Update HTML4 Hash
                if (!History.isHashEqual(newStateHash, html4Hash) && !History.isHashEqual(newStateHash, History.getShortUrl(History.getLocationHref()))) {
                    History.setHash(newStateHash, false);
                }

                History.busy(false);

                // End pushState closure
                return true;
            };

            /**
             * History.replaceState(data,title,url)
             * Replace the State and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.replaceState = function (data, title, url, queue) {
                //History.debug('History.replaceState: called', arguments);

                // We assume that the URL passed in is URI-encoded, but this makes
                // sure that it's fully URI encoded; any '%'s that are encoded are
                // converted back into '%'s
                url = encodeURI(url).replace(/%25/g, "%");

                // Check the State
                if (History.getHashByUrl(url)) {
                    throw new Error('History.js does not support states with fragment-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.replaceState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.replaceState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy
                History.busy(true);

                // Fetch the State Objects
                var newState = History.createStateObject(data, title, url),
                    newStateHash = History.getHashByState(newState),
                    oldState = History.getState(false),
                    oldStateHash = History.getHashByState(oldState),
                    previousState = History.getStateByIndex(-2);

                // Discard Old State
                History.discardState(oldState, newState, previousState);

                // If the url hasn't changed, just store and save the state
                // and fire a statechange event to be consistent with the
                // html 5 api
                if (newStateHash === oldStateHash) {
                    // Store the newState
                    History.storeState(newState);
                    History.expectedStateId = newState.id;

                    // Recycle the State
                    History.recycleState(newState);

                    // Force update of the title
                    History.setTitle(newState);

                    // Update HTML5 State
                    History.saveState(newState);

                    // Fire HTML5 Event
                    //History.debug('History.pushState: trigger popstate');
                    History.Adapter.trigger(window, 'statechange');
                    History.busy(false);
                }
                else {
                    // Alias to PushState
                    History.pushState(newState.data, newState.title, newState.url, false);
                }

                // End replaceState closure
                return true;
            };

        } // History.emulated.pushState



        // ====================================================================
        // Initialise

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /**
             * Ensure initial state is handled correctly
             */
            if (History.getHash() && !History.emulated.hashChange) {
                History.Adapter.onDomLoad(function () {
                    History.Adapter.trigger(window, 'hashchange');
                });
            }

        } // History.emulated.pushState

    }; // History.initHtml4

    // Try to Initialise History
    if (typeof History.init !== 'undefined') {
        History.init();
    }

})(window);
/**
 * History.js Core
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <https://creativecommons.org/licenses/BSD/>
 */

(function (window, undefined) {
    "use strict";

    // ========================================================================
    // Initialise

    // Localise Globals
    var
        console = window.console || undefined, // Prevent a JSLint complain
        document = window.document, // Make sure we are using the correct document
        navigator = window.navigator, // Make sure we are using the correct navigator
        sessionStorage = window.sessionStorage || false, // sessionStorage
        setTimeout = window.setTimeout,
        clearTimeout = window.clearTimeout,
        setInterval = window.setInterval,
        clearInterval = window.clearInterval,
        JSON = window.JSON,
        alert = window.alert,
        History = window.History = window.History || {}, // Public History Object
        history = window.history; // Old History Object

    try {
        sessionStorage.setItem('TEST', '1');
        sessionStorage.removeItem('TEST');
    } catch (e) {
        sessionStorage = false;
    }

    // MooTools Compatibility
    JSON.stringify = JSON.stringify || JSON.encode;
    JSON.parse = JSON.parse || JSON.decode;

    // Check Existence
    if (typeof History.init !== 'undefined') {
        throw new Error('History.js Core has already been loaded...');
    }

    // Initialise History
    History.init = function (options) {
        // Check Load Status of Adapter
        if (typeof History.Adapter === 'undefined') {
            return false;
        }

        // Check Load Status of Core
        if (typeof History.initCore !== 'undefined') {
            History.initCore();
        }

        // Check Load Status of HTML4 Support
        if (typeof History.initHtml4 !== 'undefined') {
            History.initHtml4();
        }

        // Return true
        return true;
    };


    // ========================================================================
    // Initialise Core

    // Initialise Core
    History.initCore = function (options) {
        // Initialise
        if (typeof History.initCore.initialized !== 'undefined') {
            // Already Loaded
            return false;
        }
        else {
            History.initCore.initialized = true;
        }


        // ====================================================================
        // Options

        /**
         * History.options
         * Configurable options
         */
        History.options = History.options || {};

        /**
         * History.options.hashChangeInterval
         * How long should the interval be before hashchange checks
         */
        History.options.hashChangeInterval = History.options.hashChangeInterval || 100;

        /**
         * History.options.safariPollInterval
         * How long should the interval be before safari poll checks
         */
        History.options.safariPollInterval = History.options.safariPollInterval || 500;

        /**
         * History.options.doubleCheckInterval
         * How long should the interval be before we perform a double check
         */
        History.options.doubleCheckInterval = History.options.doubleCheckInterval || 500;

        /**
         * History.options.disableSuid
         * Force History not to append suid
         */
        History.options.disableSuid = History.options.disableSuid || false;

        /**
         * History.options.storeInterval
         * How long should we wait between store calls
         */
        History.options.storeInterval = History.options.storeInterval || 1000;

        /**
         * History.options.busyDelay
         * How long should we wait between busy events
         */
        History.options.busyDelay = History.options.busyDelay || 250;

        /**
         * History.options.debug
         * If true will enable debug messages to be logged
         */
        History.options.debug = History.options.debug || false;

        /**
         * History.options.initialTitle
         * What is the title of the initial state
         */
        History.options.initialTitle = History.options.initialTitle || document.title;

        /**
         * History.options.html4Mode
         * If true, will force HTMl4 mode (hashtags)
         */
        History.options.html4Mode = History.options.html4Mode || false;

        /**
         * History.options.delayInit
         * Want to override default options and call init manually.
         */
        History.options.delayInit = History.options.delayInit || false;


        // ====================================================================
        // Interval record

        /**
         * History.intervalList
         * List of intervals set, to be cleared when document is unloaded.
         */
        History.intervalList = [];

        /**
         * History.clearAllIntervals
         * Clears all setInterval instances.
         */
        History.clearAllIntervals = function () {
            var i, il = History.intervalList;
            if (typeof il !== "undefined" && il !== null) {
                for (i = 0; i < il.length; i++) {
                    clearInterval(il[i]);
                }
                History.intervalList = null;
            }
        };


        // ====================================================================
        // Debug

        /**
         * History.debug(message,...)
         * Logs the passed arguments if debug enabled
         */
        History.debug = function () {
            if ((History.options.debug || false)) {
                History.log.apply(History, arguments);
            }
        };

        /**
         * History.log(message,...)
         * Logs the passed arguments
         */
        History.log = function () {
            // Prepare
            var
                consoleExists = !(typeof console === 'undefined' || typeof console.log === 'undefined' || typeof console.log.apply === 'undefined'),
                textarea = document.getElementById('log'),
                message,
                i, n,
                args, arg
            ;

            // Write to Console
            if (consoleExists) {
                args = Array.prototype.slice.call(arguments);
                message = args.shift();
                if (typeof console.debug !== 'undefined') {
                    console.debug.apply(console, [message, args]);
                }
                else {
                    console.log.apply(console, [message, args]);
                }
            }
            else {
                message = ("\n" + arguments[0] + "\n");
            }

            // Write to log
            for (i = 1, n = arguments.length; i < n; ++i) {
                arg = arguments[i];
                if (typeof arg === 'object' && typeof JSON !== 'undefined') {
                    try {
                        arg = JSON.stringify(arg);
                    }
                    catch (Exception) {
                        // Recursive Object
                    }
                }
                message += "\n" + arg + "\n";
            }

            // Textarea
            if (textarea) {
                textarea.value += message + "\n-----\n";
                textarea.scrollTop = textarea.scrollHeight - textarea.clientHeight;
            }
                // No Textarea, No Console
            else if (!consoleExists) {
                alert(message);
            }

            // Return true
            return true;
        };


        // ====================================================================
        // Emulated Status

        /**
         * History.getInternetExplorerMajorVersion()
         * Get's the major version of Internet Explorer
         * @return {integer}
         * @license Public Domain
         * @author Benjamin Arthur Lupton <contact@balupton.com>
         * @author James Padolsey <https://gist.github.com/527683>
         */
        History.getInternetExplorerMajorVersion = function () {
            var result = History.getInternetExplorerMajorVersion.cached =
                    (typeof History.getInternetExplorerMajorVersion.cached !== 'undefined')
                ? History.getInternetExplorerMajorVersion.cached
                : (function () {
                    var v = 3,
                            div = document.createElement('div'),
                            all = div.getElementsByTagName('i');
                    while ((div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->') && all[0]) { }
                    return (v > 4) ? v : false;
                })()
            ;
            return result;
        };

        /**
         * History.isInternetExplorer()
         * Are we using Internet Explorer?
         * @return {boolean}
         * @license Public Domain
         * @author Benjamin Arthur Lupton <contact@balupton.com>
         */
        History.isInternetExplorer = function () {
            var result =
                History.isInternetExplorer.cached =
                (typeof History.isInternetExplorer.cached !== 'undefined')
                    ? History.isInternetExplorer.cached
                    : Boolean(History.getInternetExplorerMajorVersion())
            ;
            return result;
        };

        /**
         * History.emulated
         * Which features require emulating?
         */

        if (History.options.html4Mode) {
            History.emulated = {
                pushState: true,
                hashChange: true
            };
        }

        else {

            History.emulated = {
                pushState: !Boolean(
                    window.history && window.history.pushState && window.history.replaceState
                    && !(
                        (/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i).test(navigator.userAgent) /* disable for versions of iOS before version 4.3 (8F190) */
                        || (/AppleWebKit\/5([0-2]|3[0-2])/i).test(navigator.userAgent) /* disable for the mercury iOS browser, or at least older versions of the webkit engine */
                    )
                ),
                hashChange: Boolean(
                    !(('onhashchange' in window) || ('onhashchange' in document))
                    ||
                    (History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8)
                )
            };
        }

        /**
         * History.enabled
         * Is History enabled?
         */
        History.enabled = !History.emulated.pushState;

        /**
         * History.bugs
         * Which bugs are present
         */
        History.bugs = {
            /**
             * Safari 5 and Safari iOS 4 fail to return to the correct state once a hash is replaced by a `replaceState` call
             * https://bugs.webkit.org/show_bug.cgi?id=56249
             */
            setHash: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

            /**
             * Safari 5 and Safari iOS 4 sometimes fail to apply the state change under busy conditions
             * https://bugs.webkit.org/show_bug.cgi?id=42940
             */
            safariPoll: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

            /**
             * MSIE 6 and 7 sometimes do not apply a hash even it was told to (requiring a second call to the apply function)
             */
            ieDoubleCheck: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8),

            /**
             * MSIE 6 requires the entire hash to be encoded for the hashes to trigger the onHashChange event
             */
            hashEscape: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 7)
        };

        /**
         * History.isEmptyObject(obj)
         * Checks to see if the Object is Empty
         * @param {Object} obj
         * @return {boolean}
         */
        History.isEmptyObject = function (obj) {
            for (var name in obj) {
                if (obj.hasOwnProperty(name)) {
                    return false;
                }
            }
            return true;
        };

        /**
         * History.cloneObject(obj)
         * Clones a object and eliminate all references to the original contexts
         * @param {Object} obj
         * @return {Object}
         */
        History.cloneObject = function (obj) {
            var hash, newObj;
            if (obj) {
                hash = JSON.stringify(obj);
                newObj = JSON.parse(hash);
            }
            else {
                newObj = {};
            }
            return newObj;
        };


        // ====================================================================
        // URL Helpers

        /**
         * History.getRootUrl()
         * Turns "https://mysite.com/dir/page.html?asd" into "https://mysite.com"
         * @return {String} rootUrl
         */
        History.getRootUrl = function () {
            // Create
            var rootUrl = document.location.protocol + '//' + (document.location.hostname || document.location.host);
            if (document.location.port || false) {
                rootUrl += ':' + document.location.port;
            }
            rootUrl += '/';

            // Return
            return rootUrl;
        };

        /**
         * History.getBaseHref()
         * Fetches the `href` attribute of the `<base href="...">` element if it exists
         * @return {String} baseHref
         */
        History.getBaseHref = function () {
            // Create
            var
                baseElements = document.getElementsByTagName('base'),
                baseElement = null,
                baseHref = '';

            // Test for Base Element
            if (baseElements.length === 1) {
                // Prepare for Base Element
                baseElement = baseElements[0];
                baseHref = baseElement.href.replace(/[^\/]+$/, '');
            }

            // Adjust trailing slash
            baseHref = baseHref.replace(/\/+$/, '');
            if (baseHref) baseHref += '/';

            // Return
            return baseHref;
        };

        /**
         * History.getBaseUrl()
         * Fetches the baseHref or basePageUrl or rootUrl (whichever one exists first)
         * @return {String} baseUrl
         */
        History.getBaseUrl = function () {
            // Create
            var baseUrl = History.getBaseHref() || History.getBasePageUrl() || History.getRootUrl();

            // Return
            return baseUrl;
        };

        /**
         * History.getPageUrl()
         * Fetches the URL of the current page
         * @return {String} pageUrl
         */
        History.getPageUrl = function () {
            // Fetch
            var
                State = History.getState(false, false),
                stateUrl = (State || {}).url || History.getLocationHref(),
                pageUrl;

            // Create
            pageUrl = stateUrl.replace(/\/+$/, '').replace(/[^\/]+$/, function (part, index, string) {
                return (/\./).test(part) ? part : part + '/';
            });

            // Return
            return pageUrl;
        };

        /**
         * History.getBasePageUrl()
         * Fetches the Url of the directory of the current page
         * @return {String} basePageUrl
         */
        History.getBasePageUrl = function () {
            // Create
            var basePageUrl = (History.getLocationHref()).replace(/[#\?].*/, '').replace(/[^\/]+$/, function (part, index, string) {
                return (/[^\/]$/).test(part) ? '' : part;
            }).replace(/\/+$/, '') + '/';

            // Return
            return basePageUrl;
        };

        /**
         * History.getFullUrl(url)
         * Ensures that we have an absolute URL and not a relative URL
         * @param {string} url
         * @param {Boolean} allowBaseHref
         * @return {string} fullUrl
         */
        History.getFullUrl = function (url, allowBaseHref) {
            // Prepare
            var fullUrl = url, firstChar = url.substring(0, 1);
            allowBaseHref = (typeof allowBaseHref === 'undefined') ? true : allowBaseHref;

            // Check
            if (/[a-z]+\:\/\//.test(url)) {
                // Full URL
            }
            else if (firstChar === '/') {
                // Root URL
                fullUrl = History.getRootUrl() + url.replace(/^\/+/, '');
            }
            else if (firstChar === '#') {
                // Anchor URL
                fullUrl = History.getPageUrl().replace(/#.*/, '') + url;
            }
            else if (firstChar === '?') {
                // Query URL
                fullUrl = History.getPageUrl().replace(/[\?#].*/, '') + url;
            }
            else {
                // Relative URL
                if (allowBaseHref) {
                    fullUrl = History.getBaseUrl() + url.replace(/^(\.\/)+/, '');
                } else {
                    fullUrl = History.getBasePageUrl() + url.replace(/^(\.\/)+/, '');
                }
                // We have an if condition above as we do not want hashes
                // which are relative to the baseHref in our URLs
                // as if the baseHref changes, then all our bookmarks
                // would now point to different locations
                // whereas the basePageUrl will always stay the same
            }

            // Return
            return fullUrl.replace(/\#$/, '');
        };

        /**
         * History.getShortUrl(url)
         * Ensures that we have a relative URL and not a absolute URL
         * @param {string} url
         * @return {string} url
         */
        History.getShortUrl = function (url) {
            // Prepare
            var shortUrl = url, baseUrl = History.getBaseUrl(), rootUrl = History.getRootUrl();

            // Trim baseUrl
            if (History.emulated.pushState) {
                // We are in a if statement as when pushState is not emulated
                // The actual url these short urls are relative to can change
                // So within the same session, we the url may end up somewhere different
                shortUrl = shortUrl.replace(baseUrl, '');
            }

            // Trim rootUrl
            shortUrl = shortUrl.replace(rootUrl, '/');

            // Ensure we can still detect it as a state
            if (History.isTraditionalAnchor(shortUrl)) {
                shortUrl = './' + shortUrl;
            }

            // Clean It
            shortUrl = shortUrl.replace(/^(\.\/)+/g, './').replace(/\#$/, '');

            // Return
            return shortUrl;
        };

        /**
         * History.getLocationHref(document)
         * Returns a normalized version of document.location.href
         * accounting for browser inconsistencies, etc.
         *
         * This URL will be URI-encoded and will include the hash
         *
         * @param {object} document
         * @return {string} url
         */
        History.getLocationHref = function (doc) {
            doc = doc || document;

            // most of the time, this will be true
            if (doc.URL === doc.location.href)
                return doc.location.href;

            // some versions of webkit URI-decode document.location.href
            // but they leave document.URL in an encoded state
            if (doc.location.href === decodeURIComponent(doc.URL))
                return doc.URL;

            // FF 3.6 only updates document.URL when a page is reloaded
            // document.location.href is updated correctly
            if (doc.location.hash && decodeURIComponent(doc.location.href.replace(/^[^#]+/, "")) === doc.location.hash)
                return doc.location.href;

            if (doc.URL.indexOf('#') == -1 && doc.location.href.indexOf('#') != -1)
                return doc.location.href;

            return doc.URL || doc.location.href;
        };


        // ====================================================================
        // State Storage

        /**
         * History.store
         * The store for all session specific data
         */
        History.store = {};

        /**
         * History.idToState
         * 1-1: State ID to State Object
         */
        History.idToState = History.idToState || {};

        /**
         * History.stateToId
         * 1-1: State String to State ID
         */
        History.stateToId = History.stateToId || {};

        /**
         * History.urlToId
         * 1-1: State URL to State ID
         */
        History.urlToId = History.urlToId || {};

        /**
         * History.storedStates
         * Store the states in an array
         */
        History.storedStates = History.storedStates || [];

        /**
         * History.savedStates
         * Saved the states in an array
         */
        History.savedStates = History.savedStates || [];

        /**
         * History.noramlizeStore()
         * Noramlize the store by adding necessary values
         */
        History.normalizeStore = function () {
            History.store.idToState = History.store.idToState || {};
            History.store.urlToId = History.store.urlToId || {};
            History.store.stateToId = History.store.stateToId || {};
        };

        /**
         * History.getState()
         * Get an object containing the data, title and url of the current state
         * @param {Boolean} friendly
         * @param {Boolean} create
         * @return {Object} State
         */
        History.getState = function (friendly, create) {
            // Prepare
            if (typeof friendly === 'undefined') { friendly = true; }
            if (typeof create === 'undefined') { create = true; }

            // Fetch
            var State = History.getLastSavedState();

            // Create
            if (!State && create) {
                State = History.createStateObject();
            }

            // Adjust
            if (friendly) {
                State = History.cloneObject(State);
                State.url = State.cleanUrl || State.url;
            }

            // Return
            return State;
        };

        /**
         * History.getIdByState(State)
         * Gets a ID for a State
         * @param {State} newState
         * @return {String} id
         */
        History.getIdByState = function (newState) {

            // Fetch ID
            var id = History.extractId(newState.url),
                str;

            if (!id) {
                // Find ID via State String
                str = History.getStateString(newState);
                if (typeof History.stateToId[str] !== 'undefined') {
                    id = History.stateToId[str];
                }
                else if (typeof History.store.stateToId[str] !== 'undefined') {
                    id = History.store.stateToId[str];
                }
                else {
                    // Generate a new ID
                    while (true) {
                        id = (new Date()).getTime() + String(Math.random()).replace(/\D/g, '');
                        if (typeof History.idToState[id] === 'undefined' && typeof History.store.idToState[id] === 'undefined') {
                            break;
                        }
                    }

                    // Apply the new State to the ID
                    History.stateToId[str] = id;
                    History.idToState[id] = newState;
                }
            }

            // Return ID
            return id;
        };

        /**
         * History.normalizeState(State)
         * Expands a State Object
         * @param {object} State
         * @return {object}
         */
        History.normalizeState = function (oldState) {
            // Variables
            var newState, dataNotEmpty;

            // Prepare
            if (!oldState || (typeof oldState !== 'object')) {
                oldState = {};
            }

            // Check
            if (typeof oldState.normalized !== 'undefined') {
                return oldState;
            }

            // Adjust
            if (!oldState.data || (typeof oldState.data !== 'object')) {
                oldState.data = {};
            }

            // ----------------------------------------------------------------

            // Create
            newState = {};
            newState.normalized = true;
            newState.title = oldState.title || '';
            newState.url = History.getFullUrl(oldState.url ? oldState.url : (History.getLocationHref()));
            newState.hash = History.getShortUrl(newState.url);
            newState.data = History.cloneObject(oldState.data);

            // Fetch ID
            newState.id = History.getIdByState(newState);

            // ----------------------------------------------------------------

            // Clean the URL
            newState.cleanUrl = newState.url.replace(/\??\&_suid.*/, '');
            newState.url = newState.cleanUrl;

            // Check to see if we have more than just a url
            dataNotEmpty = !History.isEmptyObject(newState.data);

            // Apply
            if ((newState.title || dataNotEmpty) && History.options.disableSuid !== true) {
                // Add ID to Hash
                newState.hash = History.getShortUrl(newState.url).replace(/\??\&_suid.*/, '');
                if (!/\?/.test(newState.hash)) {
                    newState.hash += '?';
                }
                newState.hash += '&_suid=' + newState.id;
            }

            // Create the Hashed URL
            newState.hashedUrl = History.getFullUrl(newState.hash);

            // ----------------------------------------------------------------

            // Update the URL if we have a duplicate
            if ((History.emulated.pushState || History.bugs.safariPoll) && History.hasUrlDuplicate(newState)) {
                newState.url = newState.hashedUrl;
            }

            // ----------------------------------------------------------------

            // Return
            return newState;
        };

        /**
         * History.createStateObject(data,title,url)
         * Creates a object based on the data, title and url state params
         * @param {object} data
         * @param {string} title
         * @param {string} url
         * @return {object}
         */
        History.createStateObject = function (data, title, url) {
            // Hashify
            var State = {
                'data': data,
                'title': title,
                'url': url
            };

            // Expand the State
            State = History.normalizeState(State);

            // Return object
            return State;
        };

        /**
         * History.getStateById(id)
         * Get a state by it's UID
         * @param {String} id
         */
        History.getStateById = function (id) {
            // Prepare
            id = String(id);

            // Retrieve
            var State = History.idToState[id] || History.store.idToState[id] || undefined;

            // Return State
            return State;
        };

        /**
         * Get a State's String
         * @param {State} passedState
         */
        History.getStateString = function (passedState) {
            // Prepare
            var State, cleanedState, str;

            // Fetch
            State = History.normalizeState(passedState);

            // Clean
            cleanedState = {
                data: State.data,
                title: passedState.title,
                url: passedState.url
            };

            // Fetch
            str = JSON.stringify(cleanedState);

            // Return
            return str;
        };

        /**
         * Get a State's ID
         * @param {State} passedState
         * @return {String} id
         */
        History.getStateId = function (passedState) {
            // Prepare
            var State, id;

            // Fetch
            State = History.normalizeState(passedState);

            // Fetch
            id = State.id;

            // Return
            return id;
        };

        /**
         * History.getHashByState(State)
         * Creates a Hash for the State Object
         * @param {State} passedState
         * @return {String} hash
         */
        History.getHashByState = function (passedState) {
            // Prepare
            var State, hash;

            // Fetch
            State = History.normalizeState(passedState);

            // Hash
            hash = State.hash;

            // Return
            return hash;
        };

        /**
         * History.extractId(url_or_hash)
         * Get a State ID by it's URL or Hash
         * @param {string} url_or_hash
         * @return {string} id
         */
        History.extractId = function (url_or_hash) {
            // Prepare
            var id, parts, url, tmp;

            // Extract

            // If the URL has a #, use the id from before the #
            if (url_or_hash.indexOf('#') != -1) {
                tmp = url_or_hash.split("#")[0];
            }
            else {
                tmp = url_or_hash;
            }

            parts = /(.*)\&_suid=([0-9]+)$/.exec(tmp);
            url = parts ? (parts[1] || url_or_hash) : url_or_hash;
            id = parts ? String(parts[2] || '') : '';

            // Return
            return id || false;
        };

        /**
         * History.isTraditionalAnchor
         * Checks to see if the url is a traditional anchor or not
         * @param {String} url_or_hash
         * @return {Boolean}
         */
        History.isTraditionalAnchor = function (url_or_hash) {
            // Check
            var isTraditional = !(/[\/\?\.]/.test(url_or_hash));

            // Return
            return isTraditional;
        };

        /**
         * History.extractState
         * Get a State by it's URL or Hash
         * @param {String} url_or_hash
         * @return {State|null}
         */
        History.extractState = function (url_or_hash, create) {
            // Prepare
            var State = null, id, url;
            create = create || false;

            // Fetch SUID
            id = History.extractId(url_or_hash);
            if (id) {
                State = History.getStateById(id);
            }

            // Fetch SUID returned no State
            if (!State) {
                // Fetch URL
                url = History.getFullUrl(url_or_hash);

                // Check URL
                id = History.getIdByUrl(url) || false;
                if (id) {
                    State = History.getStateById(id);
                }

                // Create State
                if (!State && create && !History.isTraditionalAnchor(url_or_hash)) {
                    State = History.createStateObject(null, null, url);
                }
            }

            // Return
            return State;
        };

        /**
         * History.getIdByUrl()
         * Get a State ID by a State URL
         */
        History.getIdByUrl = function (url) {
            // Fetch
            var id = History.urlToId[url] || History.store.urlToId[url] || undefined;

            // Return
            return id;
        };

        /**
         * History.getLastSavedState()
         * Get an object containing the data, title and url of the current state
         * @return {Object} State
         */
        History.getLastSavedState = function () {
            return History.savedStates[History.savedStates.length - 1] || undefined;
        };

        /**
         * History.getLastStoredState()
         * Get an object containing the data, title and url of the current state
         * @return {Object} State
         */
        History.getLastStoredState = function () {
            return History.storedStates[History.storedStates.length - 1] || undefined;
        };

        /**
         * History.hasUrlDuplicate
         * Checks if a Url will have a url conflict
         * @param {Object} newState
         * @return {Boolean} hasDuplicate
         */
        History.hasUrlDuplicate = function (newState) {
            // Prepare
            var hasDuplicate = false,
                oldState;

            // Fetch
            oldState = History.extractState(newState.url);

            // Check
            hasDuplicate = oldState && oldState.id !== newState.id;

            // Return
            return hasDuplicate;
        };

        /**
         * History.storeState
         * Store a State
         * @param {Object} newState
         * @return {Object} newState
         */
        History.storeState = function (newState) {
            // Store the State
            History.urlToId[newState.url] = newState.id;

            // Push the State
            History.storedStates.push(History.cloneObject(newState));

            // Return newState
            return newState;
        };

        /**
         * History.isLastSavedState(newState)
         * Tests to see if the state is the last state
         * @param {Object} newState
         * @return {boolean} isLast
         */
        History.isLastSavedState = function (newState) {
            // Prepare
            var isLast = false,
                newId, oldState, oldId;

            // Check
            if (History.savedStates.length) {
                newId = newState.id;
                oldState = History.getLastSavedState();
                oldId = oldState.id;

                // Check
                isLast = (newId === oldId);
            }

            // Return
            return isLast;
        };

        /**
         * History.saveState
         * Push a State
         * @param {Object} newState
         * @return {boolean} changed
         */
        History.saveState = function (newState) {
            // Check Hash
            if (History.isLastSavedState(newState)) {
                return false;
            }

            // Push the State
            History.savedStates.push(History.cloneObject(newState));

            // Return true
            return true;
        };

        /**
         * History.getStateByIndex()
         * Gets a state by the index
         * @param {integer} index
         * @return {Object}
         */
        History.getStateByIndex = function (index) {
            // Prepare
            var State = null;

            // Handle
            if (typeof index === 'undefined') {
                // Get the last inserted
                State = History.savedStates[History.savedStates.length - 1];
            }
            else if (index < 0) {
                // Get from the end
                State = History.savedStates[History.savedStates.length + index];
            }
            else {
                // Get from the beginning
                State = History.savedStates[index];
            }

            // Return State
            return State;
        };

        /**
         * History.getCurrentIndex()
         * Gets the current index
         * @return (integer)
        */
        History.getCurrentIndex = function () {
            // Prepare
            var index = null;

            // No states saved
            if (History.savedStates.length < 1) {
                index = 0;
            }
            else {
                index = History.savedStates.length - 1;
            }
            return index;
        };

        // ====================================================================
        // Hash Helpers

        /**
         * History.getHash()
         * @param {Location=} location
         * Gets the current document hash
         * Note: unlike location.hash, this is guaranteed to return the escaped hash in all browsers
         * @return {string}
         */
        History.getHash = function (doc) {
            var url = History.getLocationHref(doc),
                hash;
            hash = History.getHashByUrl(url);
            return hash;
        };

        /**
         * History.unescapeHash()
         * normalize and Unescape a Hash
         * @param {String} hash
         * @return {string}
         */
        History.unescapeHash = function (hash) {
            // Prepare
            var result = History.normalizeHash(hash);

            // Unescape hash
            result = decodeURIComponent(result);

            // Return result
            return result;
        };

        /**
         * History.normalizeHash()
         * normalize a hash across browsers
         * @return {string}
         */
        History.normalizeHash = function (hash) {
            // Prepare
            var result = hash.replace(/[^#]*#/, '').replace(/#.*/, '');

            // Return result
            return result;
        };

        /**
         * History.setHash(hash)
         * Sets the document hash
         * @param {string} hash
         * @return {History}
         */
        History.setHash = function (hash, queue) {
            // Prepare
            var State, pageUrl;

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.setHash: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.setHash,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Log
            //History.debug('History.setHash: called',hash);

            // Make Busy + Continue
            History.busy(true);

            // Check if hash is a state
            State = History.extractState(hash, true);
            if (State && !History.emulated.pushState) {
                // Hash is a state so skip the setHash
                //History.debug('History.setHash: Hash is a state so skipping the hash set with a direct pushState call',arguments);

                // PushState
                History.pushState(State.data, State.title, State.url, false);
            }
            else if (History.getHash() !== hash) {
                // Hash is a proper hash, so apply it

                // Handle browser bugs
                if (History.bugs.setHash) {
                    // Fix Safari Bug https://bugs.webkit.org/show_bug.cgi?id=56249

                    // Fetch the base page
                    pageUrl = History.getPageUrl();

                    // Safari hash apply
                    History.pushState(null, null, pageUrl + '#' + hash, false);
                }
                else {
                    // Normal hash apply
                    document.location.hash = hash;
                }
            }

            // Chain
            return History;
        };

        /**
         * History.escape()
         * normalize and Escape a Hash
         * @return {string}
         */
        History.escapeHash = function (hash) {
            // Prepare
            var result = History.normalizeHash(hash);

            // Escape hash
            result = window.encodeURIComponent(result);

            // IE6 Escape Bug
            if (!History.bugs.hashEscape) {
                // Restore common parts
                result = result
                    .replace(/\%21/g, '!')
                    .replace(/\%26/g, '&')
                    .replace(/\%3D/g, '=')
                    .replace(/\%3F/g, '?');
            }

            // Return result
            return result;
        };

        /**
         * History.getHashByUrl(url)
         * Extracts the Hash from a URL
         * @param {string} url
         * @return {string} url
         */
        History.getHashByUrl = function (url) {
            // Extract the hash
            var hash = String(url)
                .replace(/([^#]*)#?([^#]*)#?(.*)/, '$2')
            ;

            // Unescape hash
            hash = History.unescapeHash(hash);

            // Return hash
            return hash;
        };

        /**
         * History.setTitle(title)
         * Applies the title to the document
         * @param {State} newState
         * @return {Boolean}
         */
        History.setTitle = function (newState) {
            // Prepare
            var title = newState.title,
                firstState;

            // Initial
            if (!title) {
                firstState = History.getStateByIndex(0);
                if (firstState && firstState.url === newState.url) {
                    title = firstState.title || History.options.initialTitle;
                }
            }

            // Apply
            try {
                document.getElementsByTagName('title')[0].innerHTML = title.replace('<', '&lt;').replace('>', '&gt;').replace(' & ', ' &amp; ');
            }
            catch (Exception) { }
            document.title = title;

            // Chain
            return History;
        };


        // ====================================================================
        // Queueing

        /**
         * History.queues
         * The list of queues to use
         * First In, First Out
         */
        History.queues = [];

        /**
         * History.busy(value)
         * @param {boolean} value [optional]
         * @return {boolean} busy
         */
        History.busy = function (value) {
            // Apply
            if (typeof value !== 'undefined') {
                //History.debug('History.busy: changing ['+(History.busy.flag||false)+'] to ['+(value||false)+']', History.queues.length);
                History.busy.flag = value;
            }
                // Default
            else if (typeof History.busy.flag === 'undefined') {
                History.busy.flag = false;
            }

            // Queue
            if (!History.busy.flag) {
                // Execute the next item in the queue
                clearTimeout(History.busy.timeout);
                var fireNext = function () {
                    var i, queue, item;
                    if (History.busy.flag) return;
                    for (i = History.queues.length - 1; i >= 0; --i) {
                        queue = History.queues[i];
                        if (queue.length === 0) continue;
                        item = queue.shift();
                        History.fireQueueItem(item);
                        History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
                    }
                };
                History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
            }

            // Return
            return History.busy.flag;
        };

        /**
         * History.busy.flag
         */
        History.busy.flag = false;

        /**
         * History.fireQueueItem(item)
         * Fire a Queue Item
         * @param {Object} item
         * @return {Mixed} result
         */
        History.fireQueueItem = function (item) {
            return item.callback.apply(item.scope || History, item.args || []);
        };

        /**
         * History.pushQueue(callback,args)
         * Add an item to the queue
         * @param {Object} item [scope,callback,args,queue]
         */
        History.pushQueue = function (item) {
            // Prepare the queue
            History.queues[item.queue || 0] = History.queues[item.queue || 0] || [];

            // Add to the queue
            History.queues[item.queue || 0].push(item);

            // Chain
            return History;
        };

        /**
         * History.queue (item,queue), (func,queue), (func), (item)
         * Either firs the item now if not busy, or adds it to the queue
         */
        History.queue = function (item, queue) {
            // Prepare
            if (typeof item === 'function') {
                item = {
                    callback: item
                };
            }
            if (typeof queue !== 'undefined') {
                item.queue = queue;
            }

            // Handle
            if (History.busy()) {
                History.pushQueue(item);
            } else {
                History.fireQueueItem(item);
            }

            // Chain
            return History;
        };

        /**
         * History.clearQueue()
         * Clears the Queue
         */
        History.clearQueue = function () {
            History.busy.flag = false;
            History.queues = [];
            return History;
        };


        // ====================================================================
        // IE Bug Fix

        /**
         * History.stateChanged
         * States whether or not the state has changed since the last double check was initialised
         */
        History.stateChanged = false;

        /**
         * History.doubleChecker
         * Contains the timeout used for the double checks
         */
        History.doubleChecker = false;

        /**
         * History.doubleCheckComplete()
         * Complete a double check
         * @return {History}
         */
        History.doubleCheckComplete = function () {
            // Update
            History.stateChanged = true;

            // Clear
            History.doubleCheckClear();

            // Chain
            return History;
        };

        /**
         * History.doubleCheckClear()
         * Clear a double check
         * @return {History}
         */
        History.doubleCheckClear = function () {
            // Clear
            if (History.doubleChecker) {
                clearTimeout(History.doubleChecker);
                History.doubleChecker = false;
            }

            // Chain
            return History;
        };

        /**
         * History.doubleCheck()
         * Create a double check
         * @return {History}
         */
        History.doubleCheck = function (tryAgain) {
            // Reset
            History.stateChanged = false;
            History.doubleCheckClear();

            // Fix IE6,IE7 bug where calling history.back or history.forward does not actually change the hash (whereas doing it manually does)
            // Fix Safari 5 bug where sometimes the state does not change: https://bugs.webkit.org/show_bug.cgi?id=42940
            if (History.bugs.ieDoubleCheck) {
                // Apply Check
                History.doubleChecker = setTimeout(
                    function () {
                        History.doubleCheckClear();
                        if (!History.stateChanged) {
                            //History.debug('History.doubleCheck: State has not yet changed, trying again', arguments);
                            // Re-Attempt
                            tryAgain();
                        }
                        return true;
                    },
                    History.options.doubleCheckInterval
                );
            }

            // Chain
            return History;
        };


        // ====================================================================
        // Safari Bug Fix

        /**
         * History.safariStatePoll()
         * Poll the current state
         * @return {History}
         */
        History.safariStatePoll = function () {
            // Poll the URL

            // Get the Last State which has the new URL
            var
                urlState = History.extractState(History.getLocationHref()),
                newState;

            // Check for a difference
            if (!History.isLastSavedState(urlState)) {
                newState = urlState;
            }
            else {
                return;
            }

            // Check if we have a state with that url
            // If not create it
            if (!newState) {
                //History.debug('History.safariStatePoll: new');
                newState = History.createStateObject();
            }

            // Apply the New State
            //History.debug('History.safariStatePoll: trigger');
            History.Adapter.trigger(window, 'popstate');

            // Chain
            return History;
        };


        // ====================================================================
        // State Aliases

        /**
         * History.back(queue)
         * Send the browser history back one item
         * @param {Integer} queue [optional]
         */
        History.back = function (queue) {
            //History.debug('History.back: called', arguments);

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.back: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.back,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Make Busy + Continue
            History.busy(true);

            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function () {
                History.back(false);
            });

            // Go back
            history.go(-1);

            // End back closure
            return true;
        };

        /**
         * History.forward(queue)
         * Send the browser history forward one item
         * @param {Integer} queue [optional]
         */
        History.forward = function (queue) {
            //History.debug('History.forward: called', arguments);

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.forward: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.forward,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Make Busy + Continue
            History.busy(true);

            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function () {
                History.forward(false);
            });

            // Go forward
            history.go(1);

            // End forward closure
            return true;
        };

        /**
         * History.go(index,queue)
         * Send the browser history back or forward index times
         * @param {Integer} queue [optional]
         */
        History.go = function (index, queue) {
            //History.debug('History.go: called', arguments);

            // Prepare
            var i;

            // Handle
            if (index > 0) {
                // Forward
                for (i = 1; i <= index; ++i) {
                    History.forward(queue);
                }
            }
            else if (index < 0) {
                // Backward
                for (i = -1; i >= index; --i) {
                    History.back(queue);
                }
            }
            else {
                throw new Error('History.go: History.go requires a positive or negative integer passed.');
            }

            // Chain
            return History;
        };


        // ====================================================================
        // HTML5 State Support

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /*
             * Provide Skeleton for HTML4 Browsers
             */

            // Prepare
            var emptyFunction = function () { };
            History.pushState = History.pushState || emptyFunction;
            History.replaceState = History.replaceState || emptyFunction;
        } // History.emulated.pushState

            // Native pushState Implementation
        else {
            /*
             * Use native HTML5 History API Implementation
             */

            /**
             * History.onPopState(event,extra)
             * Refresh the Current State
             */
            History.onPopState = function (event, extra) {
                // Prepare
                var stateId = false, newState = false, currentHash, currentState;

                // Reset the double check
                History.doubleCheckComplete();

                // Check for a Hash, and handle apporiatly
                currentHash = History.getHash();
                if (currentHash) {
                    // Expand Hash
                    currentState = History.extractState(currentHash || History.getLocationHref(), true);
                    if (currentState) {
                        // We were able to parse it, it must be a State!
                        // Let's forward to replaceState
                        //History.debug('History.onPopState: state anchor', currentHash, currentState);
                        History.replaceState(currentState.data, currentState.title, currentState.url, false);
                    }
                    else {
                        // Traditional Anchor
                        //History.debug('History.onPopState: traditional anchor', currentHash);
                        History.Adapter.trigger(window, 'anchorchange');
                        History.busy(false);
                    }

                    // We don't care for hashes
                    History.expectedStateId = false;
                    return false;
                }

                // Ensure
                stateId = History.Adapter.extractEventData('state', event, extra) || false;

                // Fetch State
                if (stateId) {
                    // Vanilla: Back/forward button was used
                    newState = History.getStateById(stateId);
                }
                else if (History.expectedStateId) {
                    // Vanilla: A new state was pushed, and popstate was called manually
                    newState = History.getStateById(History.expectedStateId);
                }
                else {
                    // Initial State
                    newState = History.extractState(History.getLocationHref());
                }

                // The State did not exist in our store
                if (!newState) {
                    // Regenerate the State
                    newState = History.createStateObject(null, null, History.getLocationHref());
                }

                // Clean
                History.expectedStateId = false;

                // Check if we are the same state
                if (History.isLastSavedState(newState)) {
                    // There has been no change (just the page's hash has finally propagated)
                    //History.debug('History.onPopState: no change', newState, History.savedStates);
                    History.busy(false);
                    return false;
                }

                // Store the State
                History.storeState(newState);
                History.saveState(newState);

                // Force update of the title
                History.setTitle(newState);

                // Fire Our Event
                History.Adapter.trigger(window, 'statechange');
                History.busy(false);

                // Return true
                return true;
            };
            History.Adapter.bind(window, 'popstate', History.onPopState);

            /**
             * History.pushState(data,title,url)
             * Add a new State to the history object, become it, and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.pushState = function (data, title, url, queue) {
                //History.debug('History.pushState: called', arguments);

                // Check the State
                if (History.getHashByUrl(url) && History.emulated.pushState) {
                    throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.pushState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.pushState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy + Continue
                History.busy(true);

                // Create the newState
                var newState = History.createStateObject(data, title, url);

                // Check it
                if (History.isLastSavedState(newState)) {
                    // Won't be a change
                    History.busy(false);
                }
                else {
                    // Store the newState
                    History.storeState(newState);
                    History.expectedStateId = newState.id;

                    // Push the newState
                    history.pushState(newState.id, newState.title, newState.url);

                    // Fire HTML5 Event
                    History.Adapter.trigger(window, 'popstate');
                }

                // End pushState closure
                return true;
            };

            /**
             * History.replaceState(data,title,url)
             * Replace the State and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.replaceState = function (data, title, url, queue) {
                //History.debug('History.replaceState: called', arguments);

                // Check the State
                if (History.getHashByUrl(url) && History.emulated.pushState) {
                    throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.replaceState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.replaceState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy + Continue
                History.busy(true);

                // Create the newState
                var newState = History.createStateObject(data, title, url);

                // Check it
                if (History.isLastSavedState(newState)) {
                    // Won't be a change
                    History.busy(false);
                }
                else {
                    // Store the newState
                    History.storeState(newState);
                    History.expectedStateId = newState.id;

                    // Push the newState
                    history.replaceState(newState.id, newState.title, newState.url);

                    // Fire HTML5 Event
                    History.Adapter.trigger(window, 'popstate');
                }

                // End replaceState closure
                return true;
            };

        } // !History.emulated.pushState


        // ====================================================================
        // Initialise

        /**
         * Load the Store
         */
        if (sessionStorage) {
            // Fetch
            try {
                History.store = JSON.parse(sessionStorage.getItem('History.store')) || {};
            }
            catch (err) {
                History.store = {};
            }

            // Normalize
            History.normalizeStore();
        }
        else {
            // Default Load
            History.store = {};
            History.normalizeStore();
        }

        /**
         * Clear Intervals on exit to prevent memory leaks
         */
        History.Adapter.bind(window, "unload", History.clearAllIntervals);

        /**
         * Create the initial State
         */
        History.saveState(History.storeState(History.extractState(History.getLocationHref(), true)));

        /**
         * Bind for Saving Store
         */
        if (sessionStorage) {
            // When the page is closed
            History.onUnload = function () {
                // Prepare
                var currentStore, item, currentStoreString;

                // Fetch
                try {
                    currentStore = JSON.parse(sessionStorage.getItem('History.store')) || {};
                }
                catch (err) {
                    currentStore = {};
                }

                // Ensure
                currentStore.idToState = currentStore.idToState || {};
                currentStore.urlToId = currentStore.urlToId || {};
                currentStore.stateToId = currentStore.stateToId || {};

                // Sync
                for (item in History.idToState) {
                    if (!History.idToState.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.idToState[item] = History.idToState[item];
                }
                for (item in History.urlToId) {
                    if (!History.urlToId.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.urlToId[item] = History.urlToId[item];
                }
                for (item in History.stateToId) {
                    if (!History.stateToId.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.stateToId[item] = History.stateToId[item];
                }

                // Update
                History.store = currentStore;
                History.normalizeStore();

                // In Safari, going into Private Browsing mode causes the
                // Session Storage object to still exist but if you try and use
                // or set any property/function of it it throws the exception
                // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to
                // add something to storage that exceeded the quota." infinitely
                // every second.
                currentStoreString = JSON.stringify(currentStore);
                try {
                    // Store
                    sessionStorage.setItem('History.store', currentStoreString);
                }
                catch (e) {
                    if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
                        if (sessionStorage.length) {
                            // Workaround for a bug seen on iPads. Sometimes the quota exceeded error comes up and simply
                            // removing/resetting the storage can work.
                            sessionStorage.removeItem('History.store');
                            sessionStorage.setItem('History.store', currentStoreString);
                        } else {
                            // Otherwise, we're probably private browsing in Safari, so we'll ignore the exception.
                        }
                    } else {
                        throw e;
                    }
                }
            };

            // For Internet Explorer
            History.intervalList.push(setInterval(History.onUnload, History.options.storeInterval));

            // For Other Browsers
            History.Adapter.bind(window, 'beforeunload', History.onUnload);
            History.Adapter.bind(window, 'unload', History.onUnload);

            // Both are enabled for consistency
        }

        // Non-Native pushState Implementation
        if (!History.emulated.pushState) {
            // Be aware, the following is only for native pushState implementations
            // If you are wanting to include something for all browsers
            // Then include it above this if block

            /**
             * Setup Safari Fix
             */
            if (History.bugs.safariPoll) {
                History.intervalList.push(setInterval(History.safariStatePoll, History.options.safariPollInterval));
            }

            /**
             * Ensure Cross Browser Compatibility
             */
            if (navigator.vendor === 'Apple Computer, Inc.' || (navigator.appCodeName || '') === 'Mozilla') {
                /**
                 * Fix Safari HashChange Issue
                 */

                // Setup Alias
                History.Adapter.bind(window, 'hashchange', function () {
                    History.Adapter.trigger(window, 'popstate');
                });

                // Initialise Alias
                if (History.getHash()) {
                    History.Adapter.onDomLoad(function () {
                        History.Adapter.trigger(window, 'hashchange');
                    });
                }
            }

        } // !History.emulated.pushState


    }; // History.initCore

    // Try to Initialise History
    if (!History.options || !History.options.delayInit) {
        History.init();
    }

})(window);


/***/ }),

/***/ "B7Cr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_AccessibilityUtility_js__ = __webpack_require__("f7Ep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__ = __webpack_require__("vued");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



/**
    * class HSN.Widget.ComboBox
    *
    * Encapsulates the common functionality of the ComboBox Widget.
    * ComboBox's consist of a <textbox> field (or a <a> / <button> trigger) and a flyout (popup). Keyboard navigation enabled.
    * ComboBox's come in 4 types: ListBox, Grid, Tree, Dialog
    * Currently Supported: ListBox
    * Add support for new one's as you need them
    * // Follows aria practices for accessibility from https://www.w3.org/TR/wai-aria-practices/#combobox
    *    For now, JAWS does not do combobox's so we are rolling our own
**/

HSN.Widget.ComboBox = function () {
    var application = void 0;
    var events = new HSN.EventCoordinator();

    var container = void 0;
    var button = $();
    var textbox = $();
    var flyout = void 0;
    var srText = void 0;
    var keys = void 0;
    var triggerType = void 0;
    var flyoutType = void 0;
    var focusedItem = void 0;

    var flyoutVisible = false;
    var flyoutItemSelector = 'a, button';

    var srTextTimeout = void 0;

    var triggerTypes = {
        button: 1,
        textbox: 2
    };

    var flyoutTypes = {
        listbox: 1
        //grid: 2,
        //tree: 3,
        //dialog: 4
    };

    /**
        * new HSN.Widget.ComboBox.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.ComboBox]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        *   - textbox (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector of the <input> textbox.
        *   -    OR button (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector of the <a> or <button> element (trigger).
        *   - flyout (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector of the flyout.
        *   - triggerType (enum HSN.Widget.ComboBox.triggerTypes): Declares the type of trigger this combo box has
        *   - flyoutType (enum HSN.Widget.ComboBox.flyoutTypes): Declares the type of flyout this combo box has
        *   - flyoutItemSelector (Optional) (String) - Change the 'item' jQuery selector of flyouts
    **/
    function init(config) {
        // Required
        application = config.application;
        container = $(config.container);
        button = $(config.button);
        textbox = $(config.textbox);
        flyout = $(config.flyout);
        triggerType = config.triggerType;
        flyoutType = config.flyoutType;

        // Optional
        if (config.flyoutItemSelector) {
            flyoutItemSelector = config.flyoutItemSelector;
        }

        // Convenience
        if (!triggerType) {
            if (button) {
                triggerType = triggerTypes.button;
            } else if (textbox) {
                triggerType = triggerTypes.textbox;
            }
        }

        // Warnings
        if (triggerType == triggerTypes.button && !button) {
            console.log('Must be a button/trigger passed to config param "button"');
        }
        if (triggerType == triggerTypes.textbox && !textbox) {
            console.log('Must be a textbox passed to config param "textbox"');
        }

        keys = __WEBPACK_IMPORTED_MODULE_1_HSNDIR_AccessibilityUtility_js__["a" /* default */].GetKeys();
        bindEvents();
    }

    function destroy() {
        textbox.off('keydown', function () {
            return textboxKeydown(event);
        });
        flyout.off('keydown', function () {
            return flyoutKeydown(event);
        });

        application = container = textbox = flyout = null;
    }

    function getButton() {
        return button;
    }

    function getTextbox() {
        return textbox;
    }

    function getFlyout() {
        return flyout;
    }

    function isFocused() {
        return button.is(':focus') || textbox.is(':focus') || flyout.find(':focus').length;
    }

    function bindEvents() {
        if (triggerType == triggerTypes.button) {
            button.on('click', function (event) {
                return buttonClick(event);
            });
            button.on('keydown', function (event) {
                return buttonKeydown(event);
            });
        }
        if (triggerType == triggerTypes.textbox) {
            textbox.on('keydown', function (event) {
                return textboxKeydown(event);
            });
        }

        flyout.on('keydown', function (event) {
            return flyoutKeydown(event);
        });
    }

    function buttonClick(event) {
        toggleFlyout();

        event.preventDefault();
        event.stopPropagation();
    }

    function buttonKeydown(event) {
        var key = event.keyCode || event.which;
        var caught = true;

        if (flyoutType === flyoutTypes.listbox) {
            switch (key) {
                case keys.enter:
                    events.Trigger(HSN.Widget.ComboBox.EVENT.EXECUTE);
                    break;
                case keys.esc:
                    hideFlyout();
                    break;
                case keys.down:
                    if (flyoutVisible) {
                        focusItem(getItems().first());
                    }
                    break;
                case keys.up:
                    if (flyoutVisible) {
                        focusItem(getItems().last());
                    }
                    break;
                default:
                    caught = false;
                    break;
            }
        }

        if (caught) {
            event.preventDefault();
            event.stopPropagation();
        }

        return true;
    }

    function textboxKeydown(event) {
        var key = event.keyCode || event.which;
        var caught = true;

        if (flyoutType === flyoutTypes.listbox) {
            switch (key) {
                case keys.enter:
                    events.Trigger(HSN.Widget.ComboBox.EVENT.EXECUTE);
                    break;
                case keys.esc:
                    hideFlyout();
                    break;
                case keys.down:
                    if (flyoutVisible) {
                        focusItem(getItems().first());
                    }
                    break;
                case keys.up:
                    if (flyoutVisible) {
                        focusItem(getItems().last());
                    }
                    break;
                default:
                    caught = false;
                    break;
            }
        }

        if (caught) {
            event.preventDefault();
            event.stopPropagation();
        }

        return true;
    }

    function flyoutKeydown(event) {
        var key = event.keyCode || event.which;
        var caught = true;

        if (flyoutType === flyoutTypes.listbox) {
            switch (key) {
                case keys.enter:
                    selectItem(getFocusedItem());
                    break;
                case keys.esc:
                    hideFlyout();
                    if (triggerType == triggerTypes.button) {
                        button.focus();
                    } else if (triggerType == triggerTypes.textbox) {
                        textbox.focus();
                    }
                    break;
                case keys.left:
                    if (triggerType == triggerTypes.textbox) {
                        textboxMoveCaret(-1);
                    }
                    break;
                case keys.right:
                    if (triggerType == triggerTypes.textbox) {
                        textboxMoveCaret(1);
                    }
                    break;
                case keys.tab:
                    if (event.shiftKey) {
                        // Try to select previos item, if not one, let regular shift+tab bring us out of the flyout
                        if (focusPrevItem() != true) {
                            caught = false;
                            break;
                        }
                    } else {
                        // Try to select next item, if not one, let regular tab bring us out of the flyout
                        if (focusNextItem() != true) {
                            caught = false;
                        }
                    }
                    break;
                case keys.down:
                    focusNextItem();
                    break;
                case keys.up:
                    if (event.altKey) {
                        hideFlyout();
                        textbox.focus();
                    } else {
                        focusPrevItem();
                    }
                    break;
                case keys.home:
                    focusItem(getItems().first());
                    break;
                case keys.end:
                    focusItem(getItems().last());
                    break;
                case keys.backspace:
                    // Do nothing
                    break;
                default:
                    caught = false;
                    break;
            }
        }

        if (caught) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    function docKeyUp(event) {
        var key = event.keyCode || event.which;

        if (key != keys.tab) {
            return;
        }

        if (!isFocused()) {
            hideFlyout();
        }
    }

    function textboxMoveCaret(movement) {
        var input = textbox.get(0);

        if (!input || !input.setSelectionRange) {
            return;
        }

        textbox.focus();

        var start = input.selectionStart;
        var end = input.selectionEnd;

        if (movement == -1) {
            if (start <= 0) {
                return;
            }

            start += movement;
            input.setSelectionRange(start, start);
        } else if (movement == 1) {
            if (end >= textbox.val().length) {
                return;
            }

            end += movement;
            input.setSelectionRange(end, end);
        }
    }

    function showFlyout(shouldFocus) {
        flyout.show();
        flyoutVisible = true;

        getItems().attr('tabindex', '0');

        if (shouldFocus) {
            focusItem(getItems().first());
        }

        $(document).on('keyup', docKeyUp);
    }

    function hideFlyout() {
        flyout.hide();
        flyoutVisible = false;

        getItems().attr('tabindex', '-1');

        $(document).off('keyup', docKeyUp);
    }

    function toggleFlyout() {
        if (flyoutVisible) {
            hideFlyout();
        } else {
            events.Trigger(HSN.Widget.ComboBox.EVENT.EXECUTE);
        }
    }

    function focusItem(item) {
        if (triggerType == triggerTypes.button) {
            button.attr('aria-activedescendant', item.attr('id'));
        } else if (triggerType == triggerTypes.textbox) {
            textbox.attr('aria-activedescendant', item.attr('id'));
        }

        focusedItem = item;
        item.focus();
        events.Trigger(HSN.Widget.ComboBox.EVENT.ITEMFOCUSED);
    }

    function selectItem(item) {
        focusItem(item);
        getItems().removeClass('selected').attr('aria-selected', 'false');
        item.addClass('selected').attr('aria-selected', 'true');
        events.Trigger(HSN.Widget.ComboBox.EVENT.ITEMSELECTED);
    }

    function getItems() {
        return flyout.find(flyoutItemSelector);
    }

    function getFocusedItem() {
        if (focusedItem) {
            return focusedItem;
        } else {
            return getItems().filter(':focus');
        }
    }

    function focusNextItem() {
        var items = getItems();
        var cur = items.filter(':focus');
        var index = items.index(cur);

        if (index < items.length - 1) {
            focusItem(items.eq(index + 1));
            return true;
        } else {
            return false;
        }
    }

    function focusPrevItem() {
        var items = getItems();
        var cur = items.filter(':focus');
        var index = items.index(cur);

        if (index > 0) {
            focusItem(items.eq(index - 1));
            return true;
        } else {
            return false;
        }
    }

    function say(text) {
        prepSay();

        clearTimeout(srTextTimeout);
        srTextTimeout = setTimeout(function () {
            srText.text('');
        }, 150);

        srText.text(text);
    }

    // This is basically here to allow multiple combobox's to share a container if needed
    function prepSay() {
        var existing = container.find('screenreader-text').eq(0);

        if (!srText || !srText.length) {
            if (existing.length) {
                srText = existing;
            } else {
                srText = $('<div aria-live="assertive" class="screenreader-text visuallyhidden"></div>');
                container.append(srText);
            }
        }
    }

    return {
        init: init,
        destroy: destroy,
        events: events,
        getButton: getButton,
        getTextbox: getTextbox,
        getFlyout: getFlyout,
        getItems: getItems,
        getFocusedItem: getFocusedItem,
        focusItem: focusItem,
        selectItem: selectItem,
        showFlyout: showFlyout,
        hideFlyout: hideFlyout,
        triggerTypes: triggerTypes,
        flyoutTypes: flyoutTypes,
        isFocused: isFocused,
        say: say
    };
};

HSN.Widget.ComboBox.EVENT = {
    ACTIVATE: 'HSN.Widget.ComboBox:ACTIVATE',
    DESTORY: 'HSN.Widget.ComboBox:DESTORY',
    EXECUTE: 'HSN.Widget.ComboBox:EXECUTE',
    ITEMFOCUSED: 'HSN.Widget.ComboBox:ITEMFOCUSED',
    ITEMSELECTED: 'HSN.Widget.ComboBox:ITEMSELECTED'
};

/***/ }),

/***/ "DiT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel__ = __webpack_require__("gqkz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__ = __webpack_require__("vued");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

// http://kenwheeler.github.io/slick/




/**
* class HSN.Carousel
*
* Turns an (un)ordered list of items into a carousel that slides it's children in and out of view while providing next, previous, and page buttons.
**/
HSN.Carousel = function (config) {
    var _this = this;

    /**
    * new HSN.Carousel(config)
    * - config (Object): A configuration object for the [[HSN.Carousel]]
    *   consisting of the following keys:
    *   - carousel (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an ordered or unordered list element that is the container of the items in the carousel.
    *   - showPager (Boolean): (!No longer used) A boolean indicating whether or not to show paging dots.
    *   - touch (boolean): Indicates whether the carousel should support touch events.
    *   - featuredCell (jQuery): (!No longer used) Selector of featured cell placed before carousel.
    **/

    var $carousel = $(config.carousel);

    if (!$carousel.data('hsn-carousel')) {
        $carousel.data('hsn-carousel', true);
        this.$carousel = $carousel;

        var $parent = $carousel.parent();
        $parent.css('overflow-x', 'hidden');

        $carousel.addClass('clearfix');
        $carousel.wrap('<div class="carousel"></div>');
        $carousel.css({
            'position': 'relative',
            'margin-left': '0px',
            'list-style-type': 'none',
            'padding-left': 0,
            'clear': 'both'
        });

        var zindex = $carousel.css('z-index');
        if (zindex === 'auto') {
            zindex = 0;
            $carousel.css('z-index', zindex);
        }
        zindex++;

        var slidesToShow = Math.floor($parent.innerWidth() / $carousel.find('li:first-child').outerWidth(true));
        slidesToShow = config.slidesToShow || slidesToShow || 1;

        this._currentSpeed = this._getScrollSpeedValue(config.autoScrollSpeed);
        this._firstTransitionTime = config.firstTransitionTime || 750;

        var swipeToSlide = config.swipeToSlide !== undefined ? config.swipeToSlide : Modernizr.touchevents;
        if (config.hintMoreSlides === true) {
            swipeToSlide = false;
        }

        var slick_options = {
            infinite: config.infinite === true || config.autoScrollOnHover === true,
            swipeToSlide: swipeToSlide,

            variableWidth: config.variableWidth === true,
            slidesToShow: slidesToShow + (config.hintMoreSlides ? config.hintAmount ? config.hintAmount : .5 : 0),
            slidesToScroll: config.slidesToScroll || slidesToShow,

            waitForAnimate: false,

            autoplay: config.autoScroll === true || config.autoScrollOnHover === true,
            pauseOnHover: config.autoScrollOnHover !== true,
            autoplaySpeed: this._currentSpeed,
            fade: config.fade === true,
            speed: config.fade === true ? 600 : 300,
            centerMode: config.centerMode === true,
            accessibility: true,
            focusOnChange: true,
            focusOnSelect: config.focusOnSelect,
            vertical: config.isVertical,
            verticalSwiping: config.verticalSwiping,
            dots: config.dots === true,
            customPaging: config.customPaging,
            appendDots: config.appendDots,
            responsive: config.responsive || null
        };

        if (!config.arrowsDisabled) {
            slick_options.prevArrow = config.prevButton || $('<button class="prev" type="button" aria-label="previous products">').insertBefore($carousel);
            slick_options.nextArrow = config.nextButton || $('<button class="next" type="button" aria-label="next set of products">').insertAfter($carousel);

            $(slick_options.prevArrow).css('z-index', zindex).on('click', function () {
                if (config.navigationCoremetricsTag) {
                    cmCreateManualLinkClickTag('/previous?cm_sp=' + config.navigationCoremetricsTag + '&cm_re=' + config.navigationCoremetricsTag + '\'');
                }
            });
            $(slick_options.nextArrow).css('z-index', zindex).on('click', function () {
                if (config.navigationCoremetricsTag) {
                    cmCreateManualLinkClickTag('/next?cm_sp=' + config.navigationCoremetricsTag + '&cm_re=' + config.navigationCoremetricsTag + '\'');
                }
            });
        } else {
            slick_options.arrows = false;
        }

        $('.slick-slide').focus(function () {
            $('.slick-active').find('a').attr({
                'tabindex': '-1'
            });
            $('.slick-active').find('input').attr({
                'tabindex': '-1'
            });
        });

        var application = HSN.Instance();
        var eventCoordinator = application.Events;
        $carousel.on('init afterChange', function (event, slick) {
            if (event.target !== $carousel[0]) {
                return; // nested carousels firing events
            }

            var currentSlide = slick.currentSlide;
            _this.currentPage = currentSlide;
            eventCoordinator.Trigger(__WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__["a" /* default */].Carousel.PAGE_CHANGED, currentSlide);

            if (!config.arrowsDisabled) {
                $(slick_options.prevArrow).toggle(slick_options.infinite || currentSlide > 0);
                $(slick_options.nextArrow).toggle(slick_options.infinite || currentSlide < slick.slideCount - slick_options.slidesToShow);
            }
        });

        $carousel.slick(slick_options);

        if (config.autoScrollOnHover) {
            setTimeout(function () {
                if ($carousel.is(':hover')) {
                    _this.toggleAutoScroll(true, { firstTransitionTime: _this._firstTransitionTime });
                }
            }, 0);
            $carousel.on('mouseenter', function () {
                return _this.toggleAutoScroll(true, { firstTransitionTime: _this._firstTransitionTime });
            });
            $carousel.on('mouseleave', function () {
                return _this.toggleAutoScroll(false, { goToZero: true });
            });
        }
    }
};

/**
* HSN.Carousel.EVENT = Object
*
* An enumeration of events an [[HSN.Carousel]] can raise:
* - BEFORE_SLIDE: Right before the carousel slides: used to distinquish if slide is ensemble so other ele unrelated can be manipulated loosely
*
**/
HSN.Carousel.EVENT = __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Events_js__["a" /* default */].Carousel;

HSN.Carousel.prototype = {
    _currentSpeed: null,

    // TODO: REMOVE once fixed. -- prod script customcarousel.js is trying use these properties.
    nextButton: $(), // to attach a click event handler to next and prevButton.
    prevButton: $(), // Click handler turns off autoscroll when focused, which is already the slick-carousel default
    currentPage: 0, // After resize, resetting the page
    carouselContainer: $(), // Used to calculate # of slides to show.  Already done in the constructor.
    setCarouselWidth: function setCarouselWidth() {}, // sets the width
    setSizes: function setSizes() {}, // sets the slide sizes
    setPagerItems: function setPagerItems() {}, // TODO: expose pager options
    // End TODO:

    scrollToPage: function scrollToPage(page) {
        // negative indexing
        if (page < 0) {
            page = this.$carousel.find('li').length + page;
        }
        this.$carousel.slick('slickGoTo', page);
    },
    // serves as an enum.
    speedSettings: {
        SLOW: 1,
        MEDIUM: 2,
        FAST: 3,
        SUPERFAST: 4,
        properties: {
            1: { value: 10000 },
            2: { value: 5000 },
            3: { value: 3000 },
            4: { value: 1500 }
        }
    },
    toggleAutoScroll: function toggleAutoScroll(toggle, options) {
        var _this2 = this;

        if (!toggle && options && options.goToZero) {
            this.scrollToPage(0);
        }

        // Different speed for the first transition so users don't wait too long.
        if (toggle && options && options.firstTransitionTime) {
            this._setOptions({ 'autoplaySpeed': options.firstTransitionTime });
            this.$carousel.one('afterChange', function (event) {
                _this2._setOptions({ 'autoplaySpeed': _this2._currentSpeed });
            });
        }

        this.$carousel.slick(toggle ? 'slickPlay' : 'slickPause');
    },
    setAutoScrollSpeed: function setAutoScrollSpeed(speed) {
        this._currentSpeed = this._getScrollSpeedValue(speed);

        this._setOptions({
            'autoplaySpeed': this._currentSpeed
        });
    },
    enableTouch: function enableTouch(enabled) {},

    // Private Helpers
    _getOption: function _getOption(name) {
        return this.$carousel.slick('slickGetOption', name);
    },
    _setOptions: function _setOptions(values, refresh) {
        this.$carousel.slick('slickSetOption', values, refresh);
    },
    _getScrollSpeedValue: function _getScrollSpeedValue(speedSetting) {
        var speed = this.speedSettings.properties[speedSetting || this.speedSettings.MEDIUM].value;
        return speed || this.speedSettings.properties[this.speedSettings.MEDIUM].value;
    }
};

/***/ }),

/***/ "NY2s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HSNDIR_Widget_ComboBox__ = __webpack_require__("B7Cr");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;


/**
    * class HSN.Widget.SwatchBox
    *
    * Handles the swatch widgets in ProductCardGrid views
**/

HSN.Widget.SwatchBox = function () {
    var selector;
    var replaceImage;
    var replaceText;
    var itemSelector = 'li[role="option"]';
    var comboBoxes = [];
    var deviceInfo = HSN.Instance().DeviceInformation;
    var isMobile = deviceInfo.IsMobile && !deviceInfo.IsTablet;
    var application = HSN.Instance();

    /**
        * new HSN.Widget.SwatchBox.init(config)
        * @param {object} config: A configuration object for the [[HSN.Widget.SwatchBox]]
        *   consisting of the following keys:
        *   - selector (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will
        *     resolve to 0 or more HTML elements that will act as the root containers for the widgets.
        *   - replaceImage (bool): An optional flag to replace the .image html instead of update the <img> src
        *   - replaceText (bool): An optional flag to replace the text inside .more-swatches when swatch selected
    **/
    var init = function init(config) {
        selector = config.selector;
        replaceImage = config.replaceImage ? true : false;
        replaceText = config.replaceText ? true : false;

        $(selector).each(function (i, el) {
            var container = $(el);

            if (container.data('swatchbox-initialized') === true) {
                return true;
            } else {
                container.data('swatchbox-initialized', true);
            }

            var button = container.find('.swatchbox-button');
            var flyout = container.find('.swatchbox-flyout');
            var item = container.closest('.product-item');
            var combobox = new HSN.Widget.ComboBox();

            combobox.init({
                application: HSN.Instance(),
                container: container,
                button: button,
                flyout: flyout,
                triggerType: combobox.triggerTypes.button,
                flyoutType: combobox.flyoutTypes.listbox,
                flyoutItemSelector: itemSelector
            });

            var open = function open() {
                $.each(comboBoxes, function (i, box) {
                    box.hideFlyout();
                });

                combobox.showFlyout(true);

                HSN.ScrollToElement(item, 200, isMobile ? 40 : 0);
            };

            var selected = function selected() {
                var selectedItem = combobox.getFocusedItem();
                var image = item.find('.image img');
                var src = selectedItem.data('main-image');

                if (replaceImage) {
                    image.closest('.image').html($('<img src=' + src + '>'));
                } else {
                    image.attr('src', src);
                }
                if (replaceText) {
                    var text = selectedItem.find('.name').text();
                    container.find('.more-swatches').text(text);
                }

                combobox.hideFlyout();
                button.focus();

                application.Events.Trigger(HSN.Widget.SwatchBox.EVENTS.ITEM_SELECTED, image.closest('.image'));
            };

            var itemClick = function itemClick(e) {
                var target = $(e.currentTarget);
                combobox.selectItem(target);
                e.stopPropagation();
            };

            combobox.events.On(HSN.Widget.ComboBox.EVENT.EXECUTE, open);
            combobox.events.On(HSN.Widget.ComboBox.EVENT.ITEMSELECTED, selected);
            flyout.on('click', itemSelector, itemClick);

            comboBoxes.push(combobox);
        });
    };

    return {
        init: init
    };
};

HSN.Widget.SwatchBox.EVENTS = {
    ITEM_SELECTED: 'HSN.Widget.SwatchBox.EVENTS.ITEM_SELECTED'
};

/***/ }),

/***/ "PSNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Application_js__ = __webpack_require__("Pd1c");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;



// define EVENTs

// Desktop/Mobile split... Use Globally available HSN.BuySelector
//import "HSNDIR/BuySelector.js";

HSN.Widget.Favorite = function (config) {
    this.application = config.application;
    this.container = $(config.container);
    this.favoriteButton = $('.favorite-link', this.container);
    this.objectId = this.favoriteButton.data('object-id');
    this.objectType = this.favoriteButton.data('object-type');
    this.cmPrefix = this.favoriteButton.data('cmprefix');
    this.dataLayerUdo = this.favoriteButton.data('datalayer-udo');

    this.init();
};

HSN.Widget.Favorite.prototype = function () {
    function handleFavoritingEvents() {
        this.application.Events.On(HSN.Application.EVENT.FAVORITE_FAVORITED, function (type, id, variantId) {
            if (type !== this.objectType || id !== this.objectId) {
                return;
            }

            this.application._getFavoriteService().UpdateFavoriteLink(this.favoriteButton);
        }, this);

        this.application.Events.On(HSN.Application.EVENT.FAVORITE_UNFAVORITED, function (type, id, variantId) {
            if (type !== this.objectType || id !== this.objectId) {
                return;
            }

            this.application._getFavoriteService().UpdateFavoriteLink(this.favoriteButton);
        }, this);
    }

    function toggleFavorite(isFavorite, variantId) {
        HSN.DataLayer.helpers.favorite(this.dataLayerUdo, this.cmPrefix, this.objectType, this.objectId, isFavorite ? 0 : 1);

        this.application[isFavorite ? 'Unfavorite' : 'Favorite'](this.objectType, this.objectId, variantId);
    }

    function init() {
        if (!Modernizr.touchevents) {
            HSN.Tooltip(this.favoriteButton);
        }

        this.favoriteButton.on('click mouseup', { that: this }, function (e) {
            if (e.type == 'mouseup') {
                $(this).blur();
                return false;
            }
            var isFavorite = $(this).is('.favorited');
            var variantId = $(this).data('web-id');

            toggleFavorite.call(e.data.that, isFavorite, variantId);
            return false;
        });

        this.favoriteButton.on('touchstart mouseenter', function () {
            $(this).addClass('hover');
        });

        this.favoriteButton.on('mouseleave click', function () {
            $(this).removeClass('hover');
        });

        this.favoriteButton.on('touchmove', function () {
            var that = this;
            setTimeout(function () {
                $(that).removeClass('hover');
            }, 250);
        });

        this.application.Events.On(HSN.BuySelector.EVENT.VARIANT_SELECTED, function (variantId) {
            //TODO make this work
            //this.favoriteButton.data('web-id', variantId);
            //this.favoriteButton.attr('data-web-id', variantId);

            //this.application._getFavoriteService().UpdateFavoriteLink(this.favoriteButton);
        });

        handleFavoritingEvents.call(this);
    }

    function destroy() {
        if (this.favoriteButton) {
            this.favoriteButton.off();
        }

        if (this.application) {
            this.application.Events.Off(HSN.Application.EVENT.FAVORITE_UNFAVORITED, null, this);
            this.application.Events.Off(HSN.Application.EVENT.FAVORITE_FAVORITED, null, this);
        }

        this.application = this.container = this.favoriteButton = this.dataLayerUdo = this.objectId = this.objectType = null;
    }

    return {
        init: init,
        destroy: destroy
    };
}();

/***/ }),

/***/ "Wssu":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: https://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from https://davidwalsh.name/javascript-debounce-function
 */

/* global jQuery */

(function(factory) {
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("l/Rs")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function($) {
  'use strict';

  var readmore = 'readmore',
      defaults = {
        speed: 100,
        collapsedHeight: 200,
        heightMargin: 16,
        moreLink: '<a href="#">Read More</a>',
        lessLink: '<a href="#">Close</a>',
        embedCSS: true,
        blockCSS: 'display: block; width: 100%;',
        startOpen: false,

        // callbacks
        blockProcessed: function() {},
        beforeToggle: function() {},
        afterToggle: function() {}
      },
      cssEmbedded = {},
      uniqueIdCounter = 0;

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (! immediate) {
          func.apply(context, args);
        }
      };
      var callNow = immediate && !timeout;

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  function uniqueId(prefix) {
    var id = ++uniqueIdCounter;

    return String(prefix == null ? 'rmjs-' : prefix) + id;
  }

  function setBoxHeights(element) {
    var el = element.clone().css({
          height: 'auto',
          width: element.width(),
          maxHeight: 'none',
          overflow: 'hidden'
        }).insertAfter(element),
        expandedHeight = el.outerHeight(),
        cssMaxHeight = parseInt(el.css({maxHeight: ''}).css('max-height').replace(/[^-\d\.]/g, ''), 10),
        defaultHeight = element.data('defaultHeight');

    el.remove();

    var collapsedHeight = cssMaxHeight || element.data('collapsedHeight') || defaultHeight;

    // Store our measurements.
    element.data({
      expandedHeight: expandedHeight,
      maxHeight: cssMaxHeight,
      collapsedHeight: collapsedHeight
    })
    // and disable any `max-height` property set in CSS
    .css({
      maxHeight: 'none'
    });
  }

  var resizeBoxes = debounce(function() {
    $('[data-readmore]').each(function() {
      var current = $(this),
          isExpanded = (current.attr('aria-expanded') === 'true');

      setBoxHeights(current);

      current.css({
        height: current.data( (isExpanded ? 'expandedHeight' : 'collapsedHeight') )
      });
    });
  }, 100);

  function embedCSS(options) {
    if (! cssEmbedded[options.selector]) {
      var styles = ' ';

      if (options.embedCSS && options.blockCSS !== '') {
        styles += options.selector + ' + [data-readmore-toggle], ' +
          options.selector + '[data-readmore]{' +
            options.blockCSS +
          '}';
      }

      // Include the transition CSS even if embedCSS is false
      styles += options.selector + '[data-readmore]{' +
        'transition: height ' + options.speed + 'ms;' +
        'overflow: hidden;' +
      '}';

      (function(d, u) {
        var css = d.createElement('style');
        css.type = 'text/css';

        if (css.styleSheet) {
          css.styleSheet.cssText = u;
        }
        else {
          css.appendChild(d.createTextNode(u));
        }

        d.getElementsByTagName('head')[0].appendChild(css);
      }(document, styles));

      cssEmbedded[options.selector] = true;
    }
  }

  function Readmore(element, options) {
    this.element = element;

    this.options = $.extend({}, defaults, options);

    embedCSS(this.options);

    this._defaults = defaults;
    this._name = readmore;

    this.init();

    // IE8 chokes on `window.addEventListener`, so need to test for support.
    if (window.addEventListener) {
      // Need to resize boxes when the page has fully loaded.
      window.addEventListener('load', resizeBoxes);
      window.addEventListener('resize', resizeBoxes);
    }
    else {
      window.attachEvent('load', resizeBoxes);
      window.attachEvent('resize', resizeBoxes);
    }
  }


  Readmore.prototype = {
    init: function() {
      var current = $(this.element);

      current.data({
        defaultHeight: this.options.collapsedHeight,
        heightMargin: this.options.heightMargin
      });

      setBoxHeights(current);

      var collapsedHeight = current.data('collapsedHeight'),
          heightMargin = current.data('heightMargin');

      if (current.outerHeight(true) <= collapsedHeight + heightMargin) {
        // The block is shorter than the limit, so there's no need to truncate it.
        if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
          this.options.blockProcessed(current, false);
        }
        return true;
      }
      else {
        var id = current.attr('id') || uniqueId(),
            useLink = this.options.startOpen ? this.options.lessLink : this.options.moreLink;

        current.attr({
          'data-readmore': '',
          'aria-expanded': this.options.startOpen,
          'id': id
        });

        current.after($(useLink)
          .on('click', (function(_this) {
            return function(event) {
              _this.toggle(this, current[0], event);
            };
          })(this))
          .attr({
            'data-readmore-toggle': id,
            'aria-controls': id
          }));

        if (! this.options.startOpen) {
          current.css({
            height: collapsedHeight
          });
        }

        if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
          this.options.blockProcessed(current, true);
        }
      }
    },

    toggle: function(trigger, element, event) {
      if (event) {
        event.preventDefault();
      }

      if (! trigger) {
        trigger = $('[aria-controls="' + this.element.id + '"]')[0];
      }

      if (! element) {
        element = this.element;
      }

      var $element = $(element),
          newHeight = '',
          newLink = '',
          expanded = false,
          collapsedHeight = $element.data('collapsedHeight');

      if ($element.height() <= collapsedHeight) {
        newHeight = $element.data('expandedHeight') + 'px';
        newLink = 'lessLink';
        expanded = true;
      }
      else {
        newHeight = collapsedHeight;
        newLink = 'moreLink';
      }

      // Fire beforeToggle callback
      // Since we determined the new "expanded" state above we're now out of sync
      // with our true current state, so we need to flip the value of `expanded`
      if (this.options.beforeToggle && typeof this.options.beforeToggle === 'function') {
        this.options.beforeToggle(trigger, $element, ! expanded);
      }

      $element.css({'height': newHeight});

      // Fire afterToggle callback
      $element.on('transitionend', (function(_this) {
        return function() {
          if (_this.options.afterToggle && typeof _this.options.afterToggle === 'function') {
            _this.options.afterToggle(trigger, $element, expanded);
          }

          $(this).attr({
            'aria-expanded': expanded
          }).off('transitionend');
        }
      })(this));

      $(trigger).replaceWith($(this.options[newLink])
        .on('click', (function(_this) {
            return function(event) {
              _this.toggle(this, element, event);
            };
          })(this))
        .attr({
          'data-readmore-toggle': $element.attr('id'),
          'aria-controls': $element.attr('id')
        }));
    },

    destroy: function() {
      $(this.element).each(function() {
        var current = $(this);

        current.attr({
          'data-readmore': null,
          'aria-expanded': null
        })
          .css({
            maxHeight: '',
            height: ''
          })
          .next('[data-readmore-toggle]')
          .remove();

        current.removeData();
      });
    }
  };


  $.fn.readmore = function(options) {
    var args = arguments,
        selector = this.selector;

    options = options || {};

    if (typeof options === 'object') {
      return this.each(function() {
        if ($.data(this, 'plugin_' + readmore)) {
          var instance = $.data(this, 'plugin_' + readmore);
          instance.destroy.apply(instance);
        }

        options.selector = selector;

        $.data(this, 'plugin_' + readmore, new Readmore(this, options));
      });
    }
    else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
      return this.each(function () {
        var instance = $.data(this, 'plugin_' + readmore);
        if (instance instanceof Readmore && typeof instance[options] === 'function') {
          instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        }
      });
    }
  };

}));



/***/ }),

/***/ "ad5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_lazyload_custom_js__ = __webpack_require__("v2Q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_lazyload_custom_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_lazyload_custom_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_history_js__ = __webpack_require__("3wK4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_history_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_jquery_history_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Topology_js__ = __webpack_require__("dowF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Topology_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_HSNDIR_Topology_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Template_js__ = __webpack_require__("7LMO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Template_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_HSNDIR_Template_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_HSNDIR_Flyout_js__ = __webpack_require__("a4iX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_HSNDIR_Widget_ProductCards_js__ = __webpack_require__("vrW6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_HSNDIR_Template_ProductVideo_js__ = __webpack_require__("pVi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_HSNDIR_Template_CommPrefBrands_js__ = __webpack_require__("/Vzc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_HSNDIR_TabPanel_js__ = __webpack_require__("BBRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_HSNDIR_Widget_Favorite_js__ = __webpack_require__("PSNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_HSNDIR_Breadbox_js__ = __webpack_require__("vsRl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_HSNDIR_Breadbox2_js__ = __webpack_require__("dbDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_LIBS_jquery_jtruncate_js__ = __webpack_require__("rrzf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_LIBS_jquery_jtruncate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_LIBS_jquery_jtruncate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_HSNDIR_Widget_BloomReach_js__ = __webpack_require__("rFYr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_HSNDIR_Widget_SwatchBox__ = __webpack_require__("NY2s");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;












// Used in content





//used in childaction



/**
    * class HSN.Template.ProductGrid
    *
    * Encapsulates the functionality the Product Grid page.
    **/
HSN.Template.ProductGrid = function (config) {
    /**
    * new HSN.Template.ProductGrid(config)
    * - config (Object): A configuration object for the [[HSN.Template.ProductGrid]]
    *   consisting of the following keys:
    *   - application (HSN.Application): The [[HSN.Application]] instance this template exists within and should interact with.
    *   - container (HTMLElement): The HTML element that acts as the root container for the template.
    **/
    var __scope = this;
    this._ajaxCount = 0;

    this.Application = config.application;
    this.Container = $(config.container);
    this.Breadcrumbs = $("#breadcrumb");
    this.SwatchBox = new HSN.Widget.SwatchBox();

    this.PageSize = parseInt($("#page-size").val()) || 200;
    this._isScrollAll = HSN.Instance().GetQueryStringParam(window.location.search, "scroll") == "all" ? true : false;
    this._isBonusBuy = false;
    this._isLessman = $('#template-product-grid.lessman').length;
    this._isLessmanSearch = $('#search-index-lessman').length;

    // decide the correct url to query for more products
    var pathname = window.location.pathname.toLowerCase();

    if (pathname.startsWith('/shop')) {
        this._baseUrl = '/shop';
        if (this._isLessman) {
            this._ajaxUrl = '/show-more-products-lessman';
        } else {
            this._ajaxUrl = '/show-more-products';
        }
        this._withSlug = true;
    } else if (pathname.startsWith('/search')) {
        this._baseUrl = '/search';
        if (this._isLessman) {
            this._ajaxUrl = '/search-more-products-lessman';
        } else {
            this._ajaxUrl = '/search-more-products';
        }
        this._withSlug = false;
        this._searchQuery = HSN.Instance().GetQueryStringParam(window.location.search, 'query');
    } else if (pathname.startsWith('/bonusbuy/grid')) {
        this._baseUrl = '/bonusbuy/grid';
        this._ajaxUrl = '/bonusbuy/grid';
        this._isBonusBuy = true;
        this._withSlug = false;
        this._noTopology = true;
    }

    var productCards = new HSN.Widget.ProductCards(config); // used only for the side effect of initializing the cards' JS

    this.adjustProductGrid = function () {
        var bottomPager = $(".bottom-pager");
        var topPager = $(".top-pager");
        if (topPager.length === 0) return;

        var moduleWidth = 242;
        var moduleRightMax = topPager.position().left + topPager.outerWidth();
        var columns = 3;
        var cycleLimit = 100;

        var cycles = 0;
        var productGroups = $(".product-group");
        productGroups.each(function (index) {
            if (index > 0 && $(".list-product-item")) {
                var productGroup = $(this);
                var lastItemPosition = productGroup.prev(".item").position().left + moduleWidth;
                while (lastItemPosition < moduleRightMax && cycles++ < cycleLimit) {
                    productGroup.prev(".item").after("<div class='item module'>&nbsp;</div>");
                    lastItemPosition = productGroup.prev(".item").position().left + moduleWidth;
                }
            }
        });

        cycles = 0;
        var itemsAbovePager = $("#template-product-grid").find(".item");
        if (itemsAbovePager.length) {
            var lastItem = itemsAbovePager.last();
            __scope.UpdatePagingControlVisibility();

            var lastItemRight = lastItem.position().left + lastItem.outerWidth();
            var lastItemBottom = lastItem.position().top + lastItem.outerHeight();
            var breadbox = this.Container.find("#breadbox");
            var breadboxBottom = breadbox.length > 0 ? breadbox.position().top + breadbox.outerHeight() : 0;

            if ($(".list-product-item")) {
                while ((lastItemRight < moduleRightMax || lastItemBottom < breadboxBottom) && cycles++ < cycleLimit) {
                    if ($("#next-take").val() === "0" || $(".item").length < columns || $(".item").length + $(".in-grid").length < columns) {
                        lastItem.after("<div class='item module'></div>");
                    } else {
                        bottomPager.prev(".product-group").remove();
                    }

                    lastItem = $("#template-product-grid").find(".item").last();
                    lastItemRight = lastItem.position().left + lastItem.outerWidth();
                    lastItemBottom = lastItem.position().top + lastItem.outerHeight();
                }
            }
        }
        this.adjustCMSContent();
    };
    this.adjustCMSContent = function () {
        var $prodCards = this.Container.find('.item:not(.product-item)');

        $prodCards.each(function (i, v) {
            var $cur = $(v);
            $cur.addClass($cur.width() > 300 ? 'width-double' : 'width-single');
        });
    };
    if (!Modernizr.touchevents) {
        HSN.Tooltip(this.Container.find("[data-tooltip]"));
    }

    this.InitGrid();
    this.CheckPrivateSale();

    // setup event handlers on the Container node which will not be removed from the page.
    // filtering
    this.Container
    // filtering
    .on("click", ".filters a.clear-all, .filter-selections .clear-all a, .lnav .lnav-selected-filters .clear-all", function (e) {
        e.stopPropagation();
        e.preventDefault();

        if ($(".lnav").length > 0) {
            cmCreateManualLinkClickTag("/LNav?cm_re=FilterBy-_-Clear-filter-_-ALL&cm_sp=FilterBy-_-Clear-filter-_-ALL");
        }

        __scope.ClearAllFilters();
    }).on("click", "input[id^=\"spotlight-filter-\"]:checkbox, input[id^=\"filter-\"]:checkbox", function (e) {
        var checked = e.target.checked;
        var facetName = $(this).data("cmname");
        var prefix = $(this).is(":checked") ? "Breadbox" : "RemoveFilter";
        if ($(this).closest(".lnav-spotlight-filters-module").length > 0) {
            cmCreateManualLinkClickTag("/LNav?cm_re=" + prefix + "-_-PopularFilters-_-" + facetName);
        } else {
            var cmname = $(this).closest("dd").data("cmname");
            cmCreateManualLinkClickTag("/LNav?cm_re=" + prefix + "-_-" + cmname + "-_-" + facetName);
        }

        var ariaTag = $(this).closest('a');
        ariaTag.attr('aria-checked', checked);
        var id = $(this).data("id");
        if (checked) {
            __scope.AddFilter(id);
        } else {
            __scope.RemoveFilter(id);
        }
    }).on("click", ".filter-selections dd ul li a, .lnav .lnav-selected-filters li", function (e) {
        var name = $(this).data("name");
        var id = $(this).data("id");

        if ($(".lnav").length > 0) {
            cmCreateManualLinkClickTag("/LNav?cm_re=FilterBy-_-Clear-filter-_-" + name);
        } else {
            doCMClearSelection(name);
        }

        __scope.RemoveFilter(id);
        __scope.SendEdgecaseFilterEvent(this);

        return false;
    })

    // Lessman
    .on('click', '#selected-filters .clear-all', function (e) {
        e.stopPropagation();
        e.preventDefault();

        if (window.cmCreateManualLinkClickTag) {
            cmCreateManualLinkClickTag('/LNav?cm_re=FilterBy-_-Clear-filter-_-ALL');
        }

        __scope.ClearAllFilters();
    }).on('click', '#selected-filters ul li a', function (e) {
        e.preventDefault();

        var name = $(this).data('name');
        var id = $(this).data('id');

        if (window.cmCreateManualLinkClickTag) {
            cmCreateManualLinkClickTag('/LNav?cm_re=FilterBy-_-Clear-filter-_-' + name);
        }

        __scope.RemoveFilter(id);
        __scope.SendEdgecaseFilterEvent(this);

        return false;
    });

    // sorting
    this.Container.on('click', 'div.sort ul li a', function (e) {
        e.preventDefault();
        var cur = $(this);
        var text = cur.text();

        if (__scope._isLessman) {
            var sortId = cur.data('id');

            $('div.sort label span.selected').text(text);
            $('div.sort').data('id', sortId);
        } else {
            $('div.sort label span').text(text);
        }

        $('div.sort label').click();

        __scope.AddHistoryItem();
    }).on("blur", ".lnav-controls .sort", function () {
        $(this).attr('aria-expanded', 'false');
    }).on("keydown", ".lnav-controls .sort", function (e) {
        var key = e.keyCode;
        var expanded = this.hasAttribute('aria-expanded');
        var invalidKeys = [37, 38, 39, 40];
        invalidKeys.forEach(function (x) {
            if (x === key && !expanded) {
                e.preventDefault();
            }
        });
        if (key === 32) {
            $(this).attr('aria-expanded', 'true');
        }
    }).on("change", ".lnav-controls .sort", function (e) {
        e.preventDefault();
        var isBloomreach = $("#template-product-grid.bloomreach").length;
        if (isBloomreach) {
            window.location.href = window.location.pathname + "?sort=" + $(this).val();
        } else {
            $('h1').focus();
            __scope.AddHistoryItem();
        }
    });

    // paging
    this.Container.on("keypress", "#paging-page-1, #paging-page-2", function (e) {
        if (e.which === 13 /* enter */) {
                e.preventDefault();

                var currentPageSize = $("#take").val();
                var page = parseInt($(this).val());
                var skip = currentPageSize * page - currentPageSize;

                $("#skip").val(skip);

                __scope.AddHistoryItem();
            }
    }).on("click", ".prev a", function (e) {
        e.preventDefault();

        HSN.Template.CommPrefBrands.prototype.BrandPagePrevious();
    }).on("click", ".next a", function (e) {
        e.preventDefault();

        HSN.Template.CommPrefBrands.prototype.BrandPageNext();
    }).on("click", ".pager-link", function (e) {
        if ($(this).hasClass("disabled")) {
            return false;
        }

        //value to pass into coremetrics
        var pageValue = $(this).text();

        if ($(this).hasClass("prev-link")) {
            pageValue = "Beginning";
        } else if ($(this).hasClass("next-link")) {
            pageValue = "End";
        }

        cmCreateManualLinkClickTag("/Grid?cm_re=Grid-_-Pagination-_-" + pageValue + "&cm_sp=Grid-_-Pagination-_-" + pageValue);

        $("#skip").val($(this).data("skip"));
        $("#page").val($(this).data("page"));
        $("#take").val($(this).data("take"));
        __scope.AddHistoryItem();

        return false;
    }).on("click", ".prev-next a, .page-prev-next, #bottom-pager.v2 .previous-link, #bottom-pager.v2 .next-link", function (e) {
        e.preventDefault();

        if ($(this).hasClass("disabled")) {
            return;
        }

        var type = $(this).attr("rel");
        var skip = parseInt($("#" + type + "-skip").val());
        var page = parseInt($("#" + type + "-page").val());
        var take = parseInt($("#" + type + "-take").val());

        var coremetricsPagingArea = $(this).parents().hasClass("paged") ? "TopPagination" : "Pagination";

        var pageValue = type === "next" ? "Next" : "Previous";
        cmCreateManualLinkClickTag("/Grid?cm_re=Grid-_-" + coremetricsPagingArea + "-_-" + pageValue + "&cm_sp=Grid-_-" + coremetricsPagingArea + "-_-" + pageValue);

        $("#skip").val(skip);
        $("#page").val(page);
        $("#take").val(take);

        __scope.AddHistoryItem();
    });

    // Update the Scroll To Top callout's position as we scroll the page.
    this.ScrollToTopCallout = new ScrollToTopCallout(this.Container, ".scroll-to-top");

    // Throttle scroll actions
    var minScrollTime = 30;
    var scrollTimer,
        lastUpdateTime = 0;
    var $window = $(window);
    var $document = $(document);

    $(document).on("scroll", function (e) {
        if (!scrollTimer) {
            scrollTimer = setTimeout(function () {
                scrollTimer = null;
                lastUpdateTime = new Date().getTime();

                __scope.ScrollToTopCallout.UpdatePosition();

                // Load products as we approach the bottom of the grid
                if (__scope._isScrollAll) {
                    var windowTop = $window.scrollTop();
                    var windowHeight = $window.height();
                    var documentHeight = $document.height();
                    var scrollTrigger = 3000;

                    if (windowTop + windowHeight > documentHeight - scrollTrigger) {
                        __scope.LoadProducts();
                    }
                }
            }, minScrollTime);
        }
    });

    // Capture url changes and reload grid data.
    History.Adapter.bind(window, "statechange", function (e) {
        var state = History.getState();
        var data = state.data;

        __scope.RefreshGrid(data);
    });

    HSN.Instance().Events.Trigger(HSN.Template.ProductGrid.EVENT.LOADED);
};

HSN.Template.ProductGrid.prototype = {
    _ajaxTimer: null,
    _isScrollAll: false,
    _isLoading: false,
    _areNoMoreResults: false,
    _UiState: { PAGED: 0, SCROLL: 1 },
    PageSize: 0,

    /**
    * HSN.Template.ProductGrid#Application -> HSN.Application
    *
    * Provides access to the [[HSN.Application]] instances it interacts with.
    **/
    Application: null,

    /**
    * HSN.Template.ProductGrid#Container -> jQuery
    *
    * Provides access to the jQuery-wrapped HTMLElement that acts as the root element of the template.
    **/
    Container: null,

    /**
    * HSN.Template.ProductGrid#OnUIUpdate() -> void
    *
    * Updates the UI based on state: enables/disables paged and scrollAll UI
    **/
    OnUIUpdate: function OnUIUpdate(state) {
        switch (state) {
            case this._UiState.PAGED:
                $('.scrollAll').addClass('hide');
                $('.paged').removeClass('hide');
                $('.bottom-pagination').show();
                $('.scroll-all a').removeClass('disabled');
                $('.scroll-all a').attr('tabIndex', '0');
                $('.top-pagination-count').addClass('active');
                break;

            case this._UiState.SCROLL:
                $('.scrollAll').removeClass('hide');
                $('.paged').addClass('hide');
                $('.bottom-pagination').hide();
                $('.scroll-all a').addClass('disabled');
                $('.scroll-all a').removeAttr('tabIndex');
                $('.top-pagination-count').removeClass('active');
                break;
        }

        $('.paging-nav').removeClass('hide');
    },

    OnFilterChange: function OnFilterChange(me) {
        $("#skip").val(0);
        $("#take").val(this.PageSize);
        $("#page").val(1);

        this.RefreshFilterDisplay();
        this.AddHistoryItem();
    },

    RefreshGrid: function RefreshGrid(data) {
        if (!this._ignoreStateChange) {
            this._isScrollAll = data.scroll;
            data.topology = data.topology ? HSN.Topology.FromObject(data.topology) : HSN.Topology.FromLocation(window.location);
            data.query = HSN.Instance().GetQueryStringParam(window.location.search, "query");
            this.StartAjaxGetTimer(data);

            // Jump to the top of the page.
            document.body.scrollTop = document.documentElement.scrollTop = 0;

            $('select.sort').val(data.sort);
        }
    },

    ReplaceHistoryItem: function ReplaceHistoryItem() {
        var data = this.GetData();

        this._ignoreStateChange = true;

        History.replaceState(data, window.document.title, this.GetUrl(data));

        this._ignoreStateChange = false;
    },

    AddHistoryItem: function AddHistoryItem(forcedData) {
        var data = forcedData || this.GetData();

        // nothing to see here... you're trying to get a grid of everything
        if (!this._noTopology && !data.query && !data.topology.deptId && (!data.topology.facets || data.topology.facets.length === 0)) {
            window.location = "/";
            return;
        }

        History.pushState(data, window.document.title, this.GetUrl(data));
    },

    /**
    * HSN.Template.ProductGrid#StartAjaxGetTimer() -> void
    *
    * Sets the timer to make the AJAX call. Resets the timer if another call is made within 1 second so as not to have multiple calls.
    **/
    StartAjaxGetTimer: function StartAjaxGetTimer(data) {
        var self = this;

        if (this._ajaxTimer != null) {
            clearTimeout(this._ajaxTimer);
        }

        this._ajaxTimer = setTimeout(function () {
            self._areNoMoreResults = false;

            self.AjaxGet(data, self._isScrollAll);
        }, 1000);
    },

    /**
    * HSN.Template.ProductGrid#AjaxGet() -> void
    *
    * Gets the products satisfying the selected filters.
    **/
    AjaxGet: function AjaxGet(data, scrollAll) {
        var self = this;
        this._isLoading = true;
        this._ajaxCount += 1;
        var currentAjaxCount = this._ajaxCount;

        $.ajax(self.GetAjaxUrl(data), {
            dataType: "json",
            success: function success(responseData) {
                if (self._ajaxCount !== currentAjaxCount) return;

                if (self._isBonusBuy) {
                    var fullPage = $.parseHTML(responseData.View, document, true);

                    // Replace Page
                    self.Container.empty().append(fullPage);
                } else {
                    var $dom = $($.parseHTML(responseData.View, document, true));

                    if (self._isLessman && self._isLessmanSearch) {
                        var torso = $dom.filter('#torso.lessman-torso');

                        // Replace Grid
                        self.Container.empty().html(torso.find('#template-product-grid').html());

                        // Replace Breadcrumbs
                        $('#breadcrumbs').empty().html(torso.find('#breadcrumbs').html());
                    } else {
                        // Replace Grid
                        self.Container.empty().html($dom.filter('#template-product-grid').html());

                        // Replace Breadcrumbs
                        $('#breadcrumb').empty().html($dom.filter('#breadcrumb').html());

                        // Replace Heading
                        self.Container.parent().children('h1').empty().html($dom.filter('h1').html());
                    }
                }

                // Setup the grid
                self.InitGrid();

                self._isLoading = false;

                if (responseData.DataLayer) {
                    HSN.DataLayer.sendData(responseData.DataLayer);
                }

                HSN.DataLayer.helpers.virtualPageview(null, 'Modal: Product List', 'Product List');

                HSN.Instance().Events.Trigger(HSN.Template.ProductGrid.EVENT.RELOADED);
            }
        });
    },

    UpdatePagingControlVisibility: function UpdatePagingControlVisibility() {
        var pagingModule = $(".filtering-paging");

        var spotlightVisible = $(".top-line-filters:visible").length > 0;
        var pagingControlsVisible = $(".paging:visible").length > 0;

        if (spotlightVisible || pagingControlsVisible) {
            pagingModule.show();
        }
    },

    /**
    * HSN.Template.ProductGrid#GetData() -> object
    *
    * Returns an object used for History
    **/
    GetData: function GetData() {
        var self = this;
        var queryParams = HSN.Topology.getQueryParams(window.location);

        // remove search related params
        delete queryParams.facet;
        delete queryParams.store;

        var skip = $('#skip').val();
        var take = $('#take').val();
        var page = $('#page').val();

        var sort = $('.lnav-controls .sort').length ? $('.lnav-controls .sort').val() : $('div.sort-by select.sort').val();

        if (self._isLessman) {
            sort = $('div.sort').data('id');
        }

        var topology = HSN.Topology.FromLocation(window.location);
        topology.facets = this.GetSelectedFacetIds();

        var data = Object.assign(queryParams, {
            topology: topology, sort: sort, skip: skip, take: take, page: page, scroll: this._isScrollAll
        });

        if (this._searchQuery) {
            data.query = this._searchQuery;
        }

        return data;
    },

    /**
    * HSN.Template.ProductGrid#DoScrollAll() -> void
    *
    * Sets scroll all mode.
    **/
    DoScrollAll: function DoScrollAll() {
        if (this._isScrollAll) {
            this.OnUIUpdate(this._UiState.SCROLL);
            return;
        }

        this._isScrollAll = true;

        $("#skip").val("");
        $("#take").val("");
        $("#page").val(1);

        var data = this.GetData();
        delete data.skip;
        delete data.take;
        delete data.page;
        data.scroll = "all";
        this.AddHistoryItem(data);
    },

    /**
    * HSN.Template.ProductGrid#DoPaging() -> void
    *
    * Sets paging mode.
    **/
    DoPaging: function DoPaging() {
        this._isScrollAll = false;
        this.OnUIUpdate(this._UiState.PAGED);

        this._isScrollAll = false;

        $("#skip").val("");
        $("#take").val("");
        $("#page").val(1);

        var data = this.GetData();
        delete data.scroll;
        delete data.skip;
        delete data.take;
        this.AddHistoryItem(data);
    },

    /**
    * HSN.Template.ProductGrid#LoadProducts() -> void
    *
    * Loads the next products for scroll all mode.
    **/
    LoadProducts: function LoadProducts() {
        var self = this;

        if (this._isLoading || this._areNoMoreResults) {
            return;
        }

        var $loadingContainer = $('#loading-container');
        var nextTake = $('#next-take');
        var nextPage = $('#next-page');
        var nextSkip = $('#next-skip');
        var take = parseInt(nextTake.val());
        var page = parseInt(nextPage.val());
        var skip = parseInt(nextSkip.val());

        this._isLoading = true;
        $loadingContainer.show();

        var sort = $('div.sort-by select.sort').val();
        var data = this.GetData();
        data.page = page;
        data.skip = skip;
        data.take = take;

        var request = $.ajax(this.GetAjaxUrl(data), {
            dataType: 'json'
        });

        var self = this;
        request.done(function (responseData) {
            var $dom = $($.parseHTML(responseData.View, document));
            var items = $dom.find('.item');

            // Add Products to Grid
            if (self.Container.is('.lessman')) {
                self.Container.find('.item:last').after(items);
            } else {
                self.Container.find('.grid-right .item:last').after(items);
            }

            // Set paging info
            var nextTakeVal = parseInt($dom.find('#next-take').val());
            self._areNoMoreResults = nextTakeVal === 0;

            nextTake.val(nextTakeVal);
            nextPage.val($dom.find('#next-page').val());
            nextSkip.val($dom.find('#next-skip').val());

            $loadingContainer.hide();

            // Setup the grid
            self.InitGrid();

            self._isLoading = false;
            self.ScrollToTopCallout.UpdatePosition();

            HSN.Instance().Events.Trigger(HSN.Template.ProductGrid.EVENT.LOADEDMORE);
        });
    },

    /**
        * initalize grid, filters, and pagination
        */
    InitGrid: function InitGrid() {
        var self = this;

        this.Hydrate();
        this.RefreshFilterDisplay();

        this.Application.FlyoutManager.Add(new HSN.Flyout({
            trigger: this.Container.find('.sort label'),
            flyout: this.Container.find('.sort ul'),
            triggerEvent: HSN.Flyout.TRIGGER_EVENT.CLICK
        }));

        $('img.lazy', self.Container).lazyloadDisable({ event: 'scroll', namespace: 'gridLazyLoad' });
        $('img.lazy', self.Container).lazyload({
            skip_invisible: false, event: 'scroll', namespace: 'gridLazyLoad'
        });

        self.Container.find(".video").each(function () {
            new HSN.Template.ProductVideo({
                application: HSN.Instance(),
                container: $(this),
                triggerElement: ".video",
                videoUrls: {
                    httpUrl: $(this).data("httpUrl")
                },
                videoAnalytics: {
                    name: $(this).data("analyticName"), category: $(this).data("analyticCat")
                },
                assetId: $(this).data("assetid"),
                webpid: $(this).data("webpid"),
                backgroundColor: "#000000"
            });
        });

        //HSN.Instance()._getFavoriteService().CheckForFavorites(".favorite-link:not(.favorite-queried)");

        //  HSN.DataLayer.sendData({ 'grid_filters': null });
        //  HSN.DataLayer.helpers.virtualPageview(data.SerializedDataLayerUdo, "grid filters", "grid filters");

        self.OnUIUpdate(self._isScrollAll ? self._UiState.SCROLL : self._UiState.PAGED);
        self.adjustProductGrid();

        HSN.ResponsiveCells.prototype.StaticReRunDefault();

        self.SwatchBox.init({ selector: '.swatchbox', replaceImage: true, replaceText: true });
    },

    CheckPrivateSale: function CheckPrivateSale() {
        var self = this;
        var promoId = $("#privateSale", self.Container).data("promoId");

        if (promoId > 0) {
            $.ajax("/stores-actions/private-sale/validate-customer", {
                dataType: "json",
                method: "POST",
                data: { promotionId: promoId },
                success: function success(responseData) {
                    if (typeof responseData !== "undefined" && responseData.showEmailCapture) {
                        HSN.Instance().GetPrivateSaleEmailCaptureModal().Show(promoId);
                    }
                }
            });
        }
    },

    /**
        * Adds a filter and updates
        */
    AddFilter: function AddFilter(filterId, andUpdate) {
        andUpdate = andUpdate !== false;
        this.FilterCheckboxes[filterId].forEach(function (fcb) {
            fcb.check(true);
        });
        if (andUpdate) {
            this.OnFilterChange();
        }
    },

    /**
        * Removes a filter and updates
        */
    RemoveFilter: function RemoveFilter(filterId, andUpdate) {
        andUpdate = andUpdate !== false;
        this.FilterCheckboxes[filterId].forEach(function (fcb) {
            fcb.check(false);
        });
        if (andUpdate) {
            this.OnFilterChange();
        }
    },

    /**
        * Sets Department Id and updates
        */
    SetDepartmentId: function SetDepartmentId(deptId) {
        var data = this.GetData();
        data.topology.deptId = deptId;

        this.RefreshFilterDisplay();
        this.AddHistoryItem(data);
    },

    /**
    * HSN.Template.ProductGrid#ClearAllFilters() -> void
    *
    * Clears all selected filters.
    **/
    ClearAllFilters: function ClearAllFilters() {
        var self = this;

        var selected = this.GetSelectedFilters();
        $.each(selected, function (_, f) {
            self.RemoveFilter(f.id, false);
        });

        this.OnFilterChange();
    },

    GetSelectedFilters: function GetSelectedFilters() {
        var selectedCheckboxArrs = Object.filter(this.FilterCheckboxes, function (fcbArr, id) {
            return fcbArr[0].isChecked();
        });

        return $.map(selectedCheckboxArrs, function (fcbArr) {
            var $cb = $(fcbArr[0].checkbox);

            return {
                name: $cb.data("name"),
                id: $cb.data("id"),
                isAttribute: $cb.data("isAttribute"),
                groupName: $cb.data("group-name")
            };
        });
    },

    GetSelectedFacetIds: function GetSelectedFacetIds() {
        return this.GetSelectedFilters().map(function (f) {
            return f.id.toString();
        });
    },

    /**
        * Gets a Url that represents the current topology, sort, etc.
        * @param {object} data - additional data to pass in url.
        */
    GetUrl: function GetUrl(data) {
        var url = "";

        if (this._noTopology) {
            url = this._baseUrl;
        } else {
            url = data.topology.toUrl(this._baseUrl, this._withSlug, this._searchQuery != undefined);
        }

        var joiner = url.indexOf("?") === -1 ? "?" : "&";

        var queryData = Object.assign({}, data);
        delete queryData.topology;

        if (queryData.scroll) {
            queryData.scroll = "all";
        } else {
            delete queryData.scroll;
        }
        queryData.view = "all";

        return url + joiner + $.param(queryData, true);
    },

    /**
    * Gets a Url that represents the current topology, sort, etc.
    * @param {object} data - additional data to pass in url.
    */
    GetAjaxUrl: function GetAjaxUrl(data) {
        var url = "";
        if (this._noTopology) {
            url = this._ajaxUrl;
        } else {
            url = data.topology.toUrl(this._ajaxUrl, false);
        }
        var joiner = url.indexOf("?") === -1 ? "?" : "&";

        var queryData = Object.assign({}, data);
        delete queryData.topology;

        if (queryData.scroll) {
            queryData.scroll = "all";
        } else {
            delete queryData.scroll;
        }
        queryData.view = "all";

        return url + joiner + $.param(queryData, true);
    },

    /**
    * HSN.Template.ProductGrid#RefreshFilterDisplay() -> void
    *
    * Builds display for My Filters and breadcrumbs.
    **/
    RefreshFilterDisplay: function RefreshFilterDisplay() {
        var filtersArr = this.GetSelectedFilters();

        // Sort by name, groupName, then move Brands to top.
        filtersArr.sort(function (a, b) {
            return (a.name > b.name) - (a.name < b.name);
        }).sort(function (a, b) {
            return (a.groupName > b.groupName) - (a.groupName < b.groupName);
        }).sort(function (a, b) {
            var x = a.groupName === "Brand";
            var y = b.groupName === "Brand";

            if (x && y) return 0;
            if (x) return -1;
            if (y) return 1;
            return 0;
        });

        var buildBreadcrumbHtml = function buildBreadcrumbHtml(filters) {
            var filterCount = filters.length;
            var html = '<ul class="filtered-by">';

            if (filterCount > 0) {
                html += '<li class="different filtered-by">FILTERED BY:</li>';
            }

            html += filters.map(function (filter) {
                var id = filter.id;
                var name = filter.name.trim();
                var groupName = (filter.groupName || "").trim();

                return '<li data-id="' + id + '" data-name="' + name + '" title="Remove ' + name + '" data-group-name="' + groupName + '" class="filtered-by breadcrumb-attribute" id="breadcrumb-' + id + '" ><span>' + name + '</span></li>';
            }).join('');

            html += '</ul>';

            return html;
        };

        var buildFilteredByHtml = function buildFilteredByHtml(filters) {
            var html = "";

            html += filters.map(function (filter) {
                var id = filter.id;
                var name = filter.name.trim();
                var groupName = (filter.groupName || "").trim();

                var icon = filter.isAttribute ? "<span class='attribute-filter-icon attribute-" + id + "'></span>" : "";

                return "<li data-id=\"" + id + "\" data-name=\"" + name + "\" title=\"Remove " + name + "\" data-group-name=\"" + groupName + "\" class=\"lnav-selected-filter\" id=\"breadcrumb-" + id + "\" tabindex=\"0\">" + icon + "<span aria-hidden=\"true\">" + name + "</span></li>";
            }).join('');

            return html;
        };

        $(".lnav-selected-filters").toggle(filtersArr.length > 0);
        $(".lnav-selected-filters dd ul").html(buildFilteredByHtml(filtersArr));

        $("#breadcrumb ul.filtered-by").remove();
        $("#breadcrumb ol, #breadcrumb .searched-for").last().after(buildBreadcrumbHtml(filtersArr));

        // for IE8
        // TODO: still needed?
        $(".last-child").removeClass("last-child");
        $("#breadcrumb li").last().addClass("last-child");
    },

    SendEdgecaseFilterEvent: function SendEdgecaseFilterEvent(me) {
        if (me != null && typeof $EC != "undefined") {
            var filterAction = $(me).is(":checked") ? "select" : "unselect";
            var filterValue = $(me).data("name");
            var filterName = $(me).data("group-name");
            $EC.track('filterAction:' + filterAction, {
                filterName: filterName,
                filterValue: filterValue
            });
        }
    },

    /**
    * Hydrates event handlers and info after DOM updates.
    **/
    Hydrate: function Hydrate() {
        this.hydrateCount = (this.hydrateCount || 0) + 1;

        this.HydrateFilters();
        this.HydrateBreadcrumbs();
    },

    HydrateFilters: function HydrateFilters() {
        var self = this;
        this.FilterCheckboxes = {};

        $('input[id^="spotlight-filter-"]:checkbox, input[id^="filter-"]:checkbox').each(function (_, cb) {
            var id = $(cb).data("id");
            // Checkbox can appear in more than one group
            var fcbArr = self.FilterCheckboxes[id] || [];
            fcbArr.push(new FancyCheckbox(cb));
            self.FilterCheckboxes[id] = fcbArr;
        });
    },

    /**
    * HSN.Template.ProductGrid#HydrateBreadcrumbs -> void
    *
    * Hydrates breadcrumb event handlers after DOM updates.
    **/
    HydrateBreadcrumbs: function HydrateBreadcrumbs() {
        var self = this;

        self.Breadcrumbs = $("#breadcrumb");
        self.Breadcrumbs.on("click", "li.breadcrumb-attribute", function (e) {
            var name = $(this).data("name");
            var id = $(this).data("id");

            doCMRemoveBreadcrumb(name);
            self.RemoveFilter(id);
            self.SendEdgecaseFilterEvent(this);
        });
    }
};

HSN.Template.ProductGrid.EVENT = {
    LOADED: 'HSN.Template.ProductGrid:LOADED',
    RELOADED: 'HSN.Template.ProductGrid:RELOADED',
    LOADEDMORE: 'HSN.Template.ProductGrid:LOADEDMORE'
};

// Helper Components
// TODO: Move out into modules after webpack/babel transition is done?


/**
    * class FancyCheckbox
    * 
    * Makes checkboxes look better and changes :checked prop
    */
var FancyCheckbox = function FancyCheckbox(checkbox) {
    //var self = this;
    var $cb = $(checkbox);

    this.checkbox = $cb;
    this.span = $cb.closest("span.checkbox");

    $cb.addClass("fancy");

    //$cb.closest("li").find("label")
    //    .mousedown(function (e) {
    //        self.click(true);
    //    }).on("mouseup, mouseleave", function (e) {
    //        self.click(false);
    //    }).hover(function (e) {
    //        self.hover(true);
    //    }, function (e) {
    //        self.hover(false);
    //    });

    if (this.isChecked()) {
        this.check(true);
    }
};

FancyCheckbox.prototype = {
    isChecked: function isChecked() {
        return this.checkbox.is(":checked");
    },
    check: function check(bool) {
        // set checked prop without firing click event.
        this.checkbox.prop("checked", bool);
        this.span.toggleClass("checked", bool);

        this.click(false);
    },
    hover: function hover(bool) {
        this.span.toggleClass("hovered", bool);
    },
    click: function click(bool) {
        this.span.toggleClass("clicked", bool);
    }
};

var ScrollToTopCallout = function ScrollToTopCallout(container, elementSelector) {
    var self = this;
    var $container = $(container);
    var $window = $(window);

    var minUpdateTime = 20;
    var updateTimer,
        lastUpdateTime = 0;

    this.UpdatePosition = function () {
        /*var grid = $container;
        var scrollToTop = $(elementSelector);
          var gridHeight = grid.height();
        if (gridHeight == 0)
            gridHeight = grid.prop("scrollHeight");
          var gridOffset = grid.offset();
          if ($window.scrollTop() > 100) {
            var offset = {
                left: gridOffset.left + grid.outerWidth() - 64, top: $window.scrollTop() + $window.height() - 87
            };
                
            if (gridOffset.top + gridHeight < $window.scrollTop() + $window.height()) {
                offset.top = gridOffset.top + gridHeight - 55;
            }
            scrollToTop.offset(offset);
            scrollToTop.fadeIn({
                complete: function () {
                    // So the button is shown on initial load
                    scrollToTop.offset(offset);
                }
            });
        }
        else {
            var offset = {
                left: gridOffset.left + grid.outerWidth() - 64, top: $window.scrollTop() + $window.height() - 87
            };
            scrollToTop.offset(offset);
            scrollToTop.fadeOut();
        }
        if (gridOffset.top + gridHeight < $window.scrollTop() + $window.height()) {
            scrollToTop.offset({ top: gridOffset.top + gridHeight - 55});
        }*/
        var el = $(elementSelector);
        if ($window.scrollTop() > 100) el.fadeIn();else el.fadeOut();
    };

    $('body').on("click", elementSelector, function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
};

// helper functions
Object.filter = function (obj, predicate) {
    var result = {},
        key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }
    return result;
};

Object.map = function (obj, f) {
    var result = {},
        key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = f(obj[key]);
        }
    }
    return result;
};

// Polyfill
if (typeof String.prototype.trim !== "function") {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    };
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

/***/ }),

/***/ "dbDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

HSN.Breadbox2 = function (config) {
    var scope = this;

    this.container = $('#breadbox');
    this.cmsCells = $([]);
    this.lastHeight = 0;
    this.triggerClass = 'no-slim-bb';
    this.linksBeforeCollapse = 12;

    // This is not implemented
    this.hasBrandsFlyout = config.hasBrandsFlyout ? true : false;

    this.init = function () {
        // Select only relevant .cms-cell's to calculate height
        scope.cmsCells = $('.cms-cell').filter(function (i, e) {
            return !$(e).find('#breadcrumb, #breadbox').length;
        }).filter(function (i, e) {
            return i === 0 || $(e).is('.first');
        });

        scope.container.find('dt').on('click', scope.containerToggleClick);

        scope.container.find('.hidden-trigger').off('click', scope.hiddenTriggerClick).on('click', scope.hiddenTriggerClick);

        if (!Modernizr.touchevents) {
            HSN.Tooltip(this.container.find('[data-tooltip]'));
        }
    };

    this.unload = function () {
        clearInterval(scope.ResizerInterval);
    };

    this.resize = function (forceResize) {
        var breadboxHeight = 0;

        scope.cmsCells.each(function (i, e) {
            breadboxHeight += $(e).outerHeight();
        });

        // Padding adjustment
        breadboxHeight -= 6;

        if (breadboxHeight <= 0) {
            breadboxHeight = 0;
        }

        if (scope.lastHeight === breadboxHeight && !forceResize) {
            return;
        }

        scope.lastHeight = breadboxHeight;
        scope.container.css({ minHeight: breadboxHeight });
    };

    this.containerToggleClick = function (e) {
        var cur = $(this);
        var curContainer = cur.find(' + dd ');
        var expanded = cur.is('.expanded');

        expanded ? curContainer.slideUp(300) : curContainer.slideDown(300);

        cur.toggleClass('expanded');
        cur.attr('aria-expanded', expanded ? false : true);
    };

    this.hiddenTriggerClick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        var cur = $(this);
        var expanded = cur.is('.expanded');
        var title = cur.data('title');
        var curText = cur.find('.text');
        var parent = cur.parents('dd').eq(0);
        var iHiddenUL = parent.find('.hidden-ul');

        if (expanded) {
            iHiddenUL.slideUp(300);

            cur.removeClass('expanded');
            curText.text('See more ' + title);
        } else {
            iHiddenUL.slideDown(300);

            cur.addClass('expanded');
            curText.text('See less ' + title);

            // ADA
            iHiddenUL.find('> li > a').eq(0).focus();
        }
    };

    $(document).ready(function () {
        scope.init();
        scope.resize();
        if ($('.filtered-by').length > 1) {
            $('html, body').scrollTop($('#breadcrumb').offset().top);
        }
        $(window).on('load', scope.resize);
        scope.ResizerInterval = setInterval(scope.resize, 1000);
    });
};

HSN.Breadbox2.prototype = {};

/***/ }),

/***/ "dowF":
/***/ (function(module, exports) {

/**
* class HSN.Topology
*
* Parses and Builds urls from shop and search topologies.
**/
HSN.Topology = function (deptId, facets, slug) {
    this.deptId = deptId;
    this.facets = [].concat(facets || []);
    this.slug = slug;
};

// Static functions
HSN.Topology.FromLocation = function (location) {
    var params = HSN.Topology.getQueryParams(location);
    var pathParts = location.pathname.split('/');
    var lastPathPart = pathParts.pop() || pathParts.pop(); // handle trailing slash.
    var slug = pathParts.pop();
    var isSearch = lastPathPart.toLowerCase() === 'search';
    var deptId = null;
    var facets = [];

    if (isSearch) {
        // Ex: https://wwwlocal.hsn.com/search?store=&sort=featured&query=blue+dress&facet=12215&facet=13243&facet=7263&facet=6511
        deptId = params["store"] || "";
        facets = [].concat(params["facet"] || []);
    } else {
        // Ex: https://wwwlocal.hsn.com/shop/fashion/fa-5544-6751-6751-6752?sort=featured&view=all
        var topologyParts = lastPathPart.split("-");
        var hasDept = !!topologyParts[0].charAt(0).match(/[a-z]/i);

        if (hasDept) {
            deptId = topologyParts[0];
            facets = topologyParts.slice(1) || [];
        } else {
            facets = topologyParts;
        }

        facets = facets.concat(params["facet"] || []);
    }

    return new HSN.Topology(deptId, facets, slug);
};

HSN.Topology.FromUrl = function (url) {
    var location = document.createElement('a');
    location.href = url;

    return HSN.Topology.FromLocation(location);
};

HSN.Topology.FromObject = function (obj) {
    return new HSN.Topology(obj.deptId, obj.facets || [], obj.slug);
};

// Instance functions
HSN.Topology.prototype = {
    /**
        * @returns a url prepended with the baseUrl and slug
        */
    toUrl: function toUrl(baseUrl, withSlug, buildAsQueryString) {
        var buildAsQueryString = buildAsQueryString === true;
        var url = baseUrl;

        url += withSlug ? "/" + this.slug : "";

        url += this.toUrlPath(buildAsQueryString);

        return url;
    },

    /**
        * @returns {string} the topology portion of the url
        */
    toUrlPath: function toUrlPath(buildAsQueryString) {
        var url = "";

        if (buildAsQueryString) {
            url += "?store=" + (this.deptId || "") + "&facet=" + this.facets.join("&facet=");
        } else {
            url += "/";
            if (this.deptId) {
                url += [this.deptId].concat(this.facets).join('-');
            } else {
                if (this.facets.length > 0) {
                    url += this.facets.join('-');
                } else {
                    url += "-";
                }
            }
        }

        return url;
    },

    /**
        * Try to add a facet
        * @param {string} id - the facet id
        * @returns {bool} false if already added
        */
    addFacet: function addFacet(id) {
        var index = this.facets.indexOf(id);
        if (index !== -1) return false;

        this.facets.push(id);
        return true;
    },

    /**
        * Try to remove a facet
        * @param {string} id - the facet id
        * @returns {bool} false if already removed
        */
    removeFacet: function removeFacet(id) {
        var index = this.facets.indexOf(id);
        if (index === -1) return false;

        this.facets.splice(index, 1);
        return true;
    },

    /**
        * Clone this topology
        */
    clone: function clone() {
        return new HSN.Topology(this.deptId, this.facets, this.slug, this.buildAsQueryString, this.query);
    }
};

// Helper functions
HSN.Topology.getQueryParams = function (location) {
    var params = {};
    var parts = location.search.replace("?", "").split('&').filter(function (p) {
        return p;
    });

    for (var i = 0; i < parts.length; i++) {
        var pieces = parts[i].split("=");
        var key = pieces[0];
        if (pieces[1] !== "") {
            if (params[key]) {
                params[key] = [].concat(params[key], decodeURIComponent(pieces[1]));
            } else {
                params[key] = decodeURIComponent(pieces[1]);
            }
        }
    }

    return params;
};

/***/ }),

/***/ "ew8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Carousel_js__ = __webpack_require__("DiT2");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;




/**
* new HSN.Widget.AltImageCarousel(config)
* - config (Object): A configuration object for the [[HSN.Widget.AltImageCarousel]]
*   consisting of the following keys:
*   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
*   - container (HTMLElement | jQuery | String): A jQuery object with a ul of li's of img's
*   - preloadFirstImage (bool): UnLazy the 2nd image in the carousel
*   - useSlider (bool): Add the slider to the bottom of the container that represent slide count and position
**/
HSN.Widget.AltImageCarousel = function (config) {
    var scope = this;
    scope.application = config.application || HSN.Instance();
    scope.container = $(config.container);
    scope.carousel = $('ul', scope.container);
    scope.preloadFirstImage = config.preloadFirstImage || false;
    scope.isMobile = scope.application.DeviceInformation.IsMobile && !scope.application.DeviceInformation.IsTablet;
    scope.images = $('img', scope.carousel);

    scope.useSlider = config.useSlider || false;
    scope.sliderMarker;
    scope.sliderMarkerPercent;

    if (scope.carousel.data('hsn-carousel')) {
        return;
    }

    scope.images.show();

    new HSN.Carousel({
        carousel: scope.carousel,
        fade: true
    });

    if (scope.preloadFirstImage) {
        scope.LoadLazyImg(1);
    }

    if (scope.useSlider) {
        scope.slider = $('<div class="slider" />');
        scope.sliderMarker = $('<div class="marker" />');
        scope.container.append(scope.slider.append(scope.sliderMarker));
        scope.sliderMarkerPercent = 100 / scope.images.length;
        scope.sliderMarker.css('width', scope.sliderMarkerPercent + '%');
    }

    scope.container.on('click', '.next', scope.OnNext.bind(scope));
    scope.container.on('click', '.prev', scope.OnPrev.bind(scope));
    scope.carousel.on('beforeChange', scope.OnBeforeSlideChanged.bind(scope));
};

HSN.Widget.AltImageCarousel.prototype = {
    OnNext: function OnNext(e) {
        var scope = this;
        e.stopPropagation();
        var newIndex = scope.carousel.slick('slickCurrentSlide');
        scope.LoadLazyImg(newIndex);
        scope.LoadLazyImg(newIndex + 1);
    },
    OnPrev: function OnPrev(e) {
        e.stopPropagation();
    },
    OnBeforeSlideChanged: function OnBeforeSlideChanged(e, slick, currentSlide, nextSlide) {
        var scope = this;
        scope.LoadLazyImg(nextSlide);
        if (scope.useSlider) {
            scope.UpdateSlider(nextSlide);
        }
    },
    LoadLazyImg: function LoadLazyImg(index) {
        var scope = this;
        var cur = scope.images.eq(index).filter('.lazy-hover');
        cur.attr('src', cur.data('original')).removeClass('lazy-hover');
    },
    UpdateSlider: function UpdateSlider(index) {
        var scope = this;
        scope.sliderMarker.css('left', scope.sliderMarkerPercent * index + '%');
    },
    Destroy: function Destroy() {
        var scope = this;
        scope.carousel.slick('slickGoTo', 0, true);
        scope.carousel.slick('unslick');
        if (scope.useSlider) {
            scope.slider.remove();
        }
    }
};

/***/ }),

/***/ "gqkz":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.7.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("l/Rs")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });            

                if (slideControlIndex !== -1) {
                    $(this).attr({
                        'aria-describedby': 'slick-slide-control' + _.instanceUid + slideControlIndex
                    });
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
        
                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
            _.$slides.eq(i).attr('tabindex', 0);
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }   
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
                // for non-autoplay: once active slide (group) has updated, set focus on first newly showing slide 
                if (!_.options.autoplay) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

                    _.$slides
                        .slice(index - centerOffset, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));


/***/ }),

/***/ "pVi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/**
* class HSN.Template.ProductVideo
*
* Provides lightweight functionality for displaying videos
**/
HSN.Template.ProductVideo = function (config) {
    var scope = this;
    this.application = config.application, this.container = $(config.container) ? config.container : null;
    this.triggerElement = config.triggerElement;
    this.videoUrls = config.videoUrls;
    this.videoAnalytics = config.videoAnalytics;
    this.assetId = config.assetId;
    this.webpid = config.webpid ? config.webpid : null;
    this.backgroundColor = config.backgroundColor;
    this.videoPlayerInstance = null;
    this.Events = new HSN.EventCoordinator();
    this.videoObj = {};

    //play video without container
    if (!this.container) {
        this.PlayVideo();
        return false;
    }

    //events
    this.container.on('click', this.container.find(this.triggerElement), function () {
        scope.PlayVideo();
        return false;
    });
};

HSN.Template.ProductVideo.EVENT = {
    VIDEO_STOP: 'video:stop',
    AFTER_MODAL_OPEN: 'video:after_modal_open'
};

HSN.Template.ProductVideo.prototype = {
    Events: null,
    PlayVideo: function PlayVideo() {
        var enableCaptions = false;
        var captionUrl = "";

        //use getcaptions service if webpid is passed in:
        if (this.webpid && this.assetId) {
            enableCaptions = true;
            captionUrl = "https://" + location.host + "/services/getcaptions/" + this.webpid + "/" + this.assetId;
        }

        this.videoObj = {
            media: {
                title: this.videoAnalytics.name,
                source: [{ src: this.videoUrls.httpUrl, type: 'video/mp4' }],
                track: [{ kind: 'captions', type: 'application/x-subrip', srclang: 'en', src: captionUrl }]
            },
            autoplay: true,

            captioning: {
                enabled: enableCaptions
            }
        };

        this.videoObj.category = this.videoAnalytics.category;
        this.videoObj.name = this.videoAnalytics.name;
        this.videoObj.label = this.videoAnalytics.label;

        //display video in modal:        
        var vidModal = HSN.Instance().GetVideoModal();
        HSN.Instance().Events.Trigger(HSN.Template.ProductVideo.EVENT.AFTER_MODAL_OPEN, { videoObject: this, videoModal: vidModal });
        vidModal.Show(this.videoObj, 724, 408, true, true);
    },

    StopVideo: function StopVideo() {
        this.GetVideoInstance().stop();
    },

    GetVideoInstance: function GetVideoInstance() {
        return this.videoPlayerInstance;
    },

    SetVideoInstance: function SetVideoInstance(instance) {
        this.videoPlayerInstance = instance;
    }
};

/***/ }),

/***/ "rFYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_clamp_js__ = __webpack_require__("qBtQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_LIBS_clamp_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_LIBS_clamp_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_readmore_js__ = __webpack_require__("Wssu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_LIBS_readmore_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_LIBS_readmore_js__);

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;






HSN.Widget.BloomReach = function (config) {
    this.application = config.application;
    this.container = $(config.container);
    this.readMoreWidget = null;
    this.products = null;

    this.init();
};

HSN.Widget.BloomReach.prototype = function () {
    function init() {
        var isMobile = this.application.DeviceInformation.IsMobile;

        if (isMobile) {
            this.readMoreWidget = $('.bloomreach-related-products .product-desc', this.container).readmore({
                speed: 100,
                lessLink: '<a class="read-more" href="#">Less <</a>',
                moreLink: '<a class="read-more" href="#">More ></a>',
                startOpen: false
            });
        } else {
            $('.bloomreach-related-products .product-desc a', this.container).each(function () {
                $clamp($(this)[0], { clamp: 4, splitOnChars: [''] });
            });
            $('.bloomreach-related-products .product-name a', this.container).each(function () {
                $clamp($(this)[0], { clamp: 3, splitOnChars: [''] });
            });

            this.products = $('.bloomreach-related-products ul li', this.container).on('mouseenter.bloomreach', function () {
                $(this).find('.quickview-container').show();
            }).on('mouseleave.bloomreach', function () {
                $(this).find('.quickview-container').hide();
            });
        }
    }
    function destroy() {
        this.application = null;
        this.container = null;

        this.products.off('mouseenter.bloomreach mouseleave.bloomreach');
        if (this.readMoreWidget) {
            this.readMoreWidget.destroy();
        }
    }

    return {
        init: init,
        destroy: destroy
    };
}();

/***/ }),

/***/ "rrzf":
/***/ (function(module, exports) {

(function($){
	$.fn.jTruncate = function(options) {
	   
		var defaults = {
			length: 300,
			minTrail: 20,
			moreText: "more",
			lessText: "less",
			ellipsisText: "...",
			moreAni: "",
			lessAni: ""
		};
		
		var options = $.extend(defaults, options);
	   
		return this.each(function() {
			obj = $(this);
			var body = obj.html();
			
			if(body.length > options.length + options.minTrail) {
				var splitLocation = body.indexOf(' ', options.length);
				if(splitLocation != -1) {
					// truncate tip
					var splitLocation = body.indexOf(' ', options.length);
					var str1 = body.substring(0, splitLocation);
					var str2 = body.substring(splitLocation, body.length - 1);
					obj.html(str1 + '<span class="truncate_ellipsis">' + options.ellipsisText + 
					    '<a href="#" class="truncate_more_link">' + options.moreText + '</a>' +
						'</span>' + '<span class="truncate_more">' + str2 + '</span>');
					obj.find('.truncate_more').css("display", "none");
					
					// set onclick event for more/less link
					var moreLink = $('.truncate_more_link', obj);
					var moreContent = $('.truncate_more', obj);
					var ellipsis = $('.truncate_ellipsis', obj);
					moreLink.click(function() {
						if(moreLink.text() == options.moreText) {
							moreContent.show(options.moreAni);
							moreLink.text(options.lessText);
							ellipsis.css("display", "none");
						} else {
							moreContent.hide(options.lessAni);
							moreLink.text(options.moreText);
							ellipsis.css("display", "inline");
						}
						return false;
				  	});
				}
			} // end if
			
		});
	};
})(jQuery);

/***/ }),

/***/ "v2Q6":
/***/ (function(module, exports) {

﻿/*
 * Lazy Load - jQuery plugin for lazy loading images
 *
 * Copyright (c) 2007-2013 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   https://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   https://www.appelsiini.net/projects/lazyload
 *
 * Version:  1.9.3
 *
 */

// Notes: - Don't use "display: none" with .lazy, doesn't work with .offset(), result is offset.top = 0, loads immediately
//          Visibility or opacity is fine
//        - Chrome emulation zoom does not work properly

(function ($, window, document, undefined) {
    var $window = $(window);

    $.fn.lazyload = function (options) {
        var elements = this;
        var $container;
        var settings = {
            threshold: 0,
            event: 'scroll',
            namespace: 'lazyGlobal',
            effect: 'show',
            container: window,
            data_attribute: 'original',
            skip_invisible: true,
            appear: null,
            load: null,
            placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC'
        };

        if (options) {
            $.extend(settings, options);
        }

        var update = function() {
            elements.each(function () {
                var $this = $(this);
                if (settings.skip_invisible && !$this.is(':visible')) {
                    return true;
                }

                if ($.inviewport(this, settings)) {
                    $this.trigger('appear');
                }

                return true;
            });

        }

        /* Cache container as jQuery as object. */
        $container = (settings.container === undefined ||
                      settings.container === window) ? $window : $(settings.container);

        var updateTimeout = null;

        var updateDelayed = function () {
            if (updateTimeout) {
                clearTimeout(updateTimeout);
            }
            updateTimeout = setTimeout(function () {
                update();
            }, 100);
        };

        /* Fire one scroll event per scroll. Not one scroll event per image. */
        if (settings.event === 'scroll') {
            $container.on(settings.event + '.' + settings.namespace, updateDelayed);
        }

        elements.each(function () {
            var self = this;
            var $self = $(self);

            self.loaded = false;

            /* If no src attribute given use data:uri. */
            if ($self.attr("src") === undefined || $self.attr("src") === false) {
                if ($self.is("img")) {
                    $self.attr("src", settings.placeholder);
                }
            }

            /* When appear is triggered load original image. */
            $self.one("appear", function () {
                if (!this.loaded) {
                    if (settings.appear) {
                        var elementsLeft = elements.length;
                        settings.appear.call(self, elementsLeft, settings);
                    }
                    $("<img />")
                        .on("load", function () {

                            var original = $self.attr("data-" + settings.data_attribute);
                            $self.hide();
                            if ($self.is("img")) {
                                $self.attr("src", original);
                            } else {
                                $self.css("background-image", "url('" + original + "')");
                            }
                            $self[settings.effect](settings.effect_speed);

                            self.loaded = true;

                            /* Remove image from array so it is not looped next time. */
                            var temp = $.grep(elements, function (element) {
                                return !element.loaded;
                            });
                            elements = $(temp);

                            if (settings.load) {
                                var elementsLeft = elements.length;
                                settings.load.call(self, elementsLeft, settings);
                            }
                        })
                        .attr("src", $self.attr("data-" + settings.data_attribute));
                }
            });

            /* When wanted event is triggered load original image */
            /* by triggering appear.                              */
            if (settings.event !== 'scroll') {
                $self.on(settings.event + '.' + settings.namespace, function () {
                    if (!self.loaded) {
                        $self.trigger("appear");
                    }
                });
            }
        });

        /* With IOS5 force loading images when navigating with back button. */
        /* Non optimal workaround. */
        if ((/(?:iphone|ipod|ipad).*os 5/gi).test(navigator.appVersion)) {
            $window.on("pageshow", function (event) {
                if (event.originalEvent && event.originalEvent.persisted) {
                    elements.each(function () {
                        $(this).trigger("appear");
                    });
                }
            });
        }

        $(update);

        $window.on('resize.' + settings.namespace, updateDelayed)
            .on('lazyLoadUpdate.' + settings.namespace, update);

        return this;
    };

    /* Convenience methods in jQuery namespace.           */
    /* Use as  $.belowthefold(element, {threshold : 100, container : window}) */

    $.belowthefold = function (element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
        } else {
            fold = $(settings.container).offset().top + $(settings.container).height();
        }

        return fold <= $(element).offset().top - settings.threshold;
    };

    $.rightoffold = function (element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = (window.innerWidth ? window.innerWidth : $window.width()) + $window.scrollLeft();
        } else {
            fold = $(settings.container).offset().left + $(settings.container).width();
        }

        return fold <= $(element).offset().left - settings.threshold;
    };

    $.abovethetop = function (element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.scrollTop();
        } else {
            fold = $(settings.container).offset().top;
        }

        return fold >= $(element).offset().top + settings.threshold + $(element).height();
    };

    $.leftofbegin = function (element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.scrollLeft();
        } else {
            fold = $(settings.container).offset().left;
        }

        return fold >= $(element).offset().left + settings.threshold + $(element).width();
    };

    $.inviewport = function (element, settings) {
        return !$.belowthefold(element, settings) && !$.abovethetop(element, settings)
            && !$.rightoffold(element, settings) && !$.leftofbegin(element, settings);
    };

    // Disable lazyload
    $.fn.lazyloadDisable = function (options) {
        var settings = {
            event: 'scroll',
            namespace: 'lazyGlobal'
        };
        $.extend(settings, options);
        var trigger = settings.event + '.' + settings.namespace;

        // Unbind window events (resize, pageshow...)
        $window.off(trigger)
            .off('resize.' + settings.namespace)
            .off('lazyLoadUpdate.' + settings.namespace);
        // Unbind container events (move...)
        var $container = (settings.container === undefined || settings.container === window) ? $window : $(settings.container);
        $container.off(trigger);
        // Unbind elements events (appear...)
        this.off(trigger);
        return this;
    };

    /* Custom selectors for your convenience.   */
    /* Use as $("img:below-the-fold").something() or */
    /* $("img").filter(":below-the-fold").something() which is faster */

    $.extend($.expr.pseudos, {
        "below-the-fold": function (a) { return $.belowthefold(a, { threshold: 0 }); },
        "above-the-top": function (a) { return !$.belowthefold(a, { threshold: 0 }); },
        "right-of-screen": function (a) { return $.rightoffold(a, { threshold: 0 }); },
        "left-of-screen": function (a) { return !$.rightoffold(a, { threshold: 0 }); },
        "in-viewport": function (a) { return $.inviewport(a, { threshold: 0 }); }
    });

})(jQuery, window, document);


/***/ }),

/***/ "vrW6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js__ = __webpack_require__("QrS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Widget_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Widget_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Template_ProductVideo_js__ = __webpack_require__("pVi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HSNDIR_Carousel_js__ = __webpack_require__("DiT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_HSNDIR_Widget_AltImageCarousel_js__ = __webpack_require__("ew8Z");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;







var Video = HSN.Widget.Video;
var modernizr = Modernizr;

HSN.Widget.ProductCards = function () {
    /// <summary>Encapsulates the functionality of a Product Card.</summary>
    /// <param name="config" type="object">
    /// A set of key/value pairs that configure the ProductCards.
    /// - application (HSN.Application): The [[HSN.Application]] instance this template exists within and should interact with.
    /// - container (HTMLElement): The HTML element that acts as the root container for the template.
    /// </param>

    /* Instances shared properties go here, dont use this keyword here */

    var previewElement = null;
    var getPreviewElement = function getPreviewElement() {
        ///<summary>Lazy-instantiates and provides access to the jQuery-wrapped HTMLElement that acts as the preview button for each of the product cards in the grid.</summary>
        ///<returns type="jQuery">preview element</returns>
        if (null === previewElement) {
            if ($('.bloomreach').length) {
                previewElement = $('<div class="quick-view">Quick View</div>');
            } else {
                previewElement = $('<div class="preview">Preview</div>');
            }
        }
        return previewElement;
    };

    // Returns card position taking into account ingridcards but ignoring hook logic
    function getCardPosition(webId) {
        var index = 0;
        var skipStr = HSN.Instance().GetQueryStringParam(window.location.href, "skip");
        var skip = skipStr ? parseInt(skipStr) : 0;
        var found = false;

        // Prevent div with class .item underneath left item from counting
        var parent = $("#template-product-grid .grid-right");
        if (!parent.length) parent = $("#template-product-grid");

        parent.find(".item").each(function () {
            var cur = $(this);
            var curId = cur.data("productId");

            index += 1;

            if (curId && curId == webId) {
                found = true;
                return false;
            }
        });

        if (found) {
            return skip + index;
        } else {
            return 0;
        }
    }

    var bindEvents = function bindEvents() {
        var scope = this;
        $('body').on('click', '.lessman-pdcard-video', function () {
            // ReSharper disable once UnusedLocals
            var productVideo = new HSN.Template.ProductVideo({
                application: HSN.Instance(),
                videoUrls: { httpUrl: $(this).data('httpUrl') },
                videoAnalytics: { name: $(this).data('analyticName'), category: $(this).data('analyticCat') },
                assetId: $(this).data('assetid'),
                webpid: $(this).data('productId'),
                backgroundColor: '#000000'
            });

            return false;
        }).on('click', '.brand-item, .product-item, .list-product-item, .tall-product-item', function () {
            // Make the entire product card clickable to the product detail page unless a lower element overrides.
            if (this.className !== 'item product-item module violated in-grid' && $('#all-brands-form').length === 0) {
                var cur = $(this);

                var url = cur.find('h3>a').attr('href');
                if (url == undefined) {
                    url = cur.data('product-url');
                }

                var id = cur.data('productId');
                var matrixId = cur.data('matrixId');
                var curId = !matrixId || matrixId == 0 ? id : matrixId;

                if (cur.parents('.is-host-closet').length) {
                    HSN.DataLayer.helpers.metricEvent(null, 'RE:programguide', 'hosts-closet', curId);
                } else {
                    HSN.DataLayer.helpers.hsnEvent({
                        'product_variant_id': curId,
                        'product_position': getCardPosition(id),
                        'product_click_id': curId,
                        'matrix_id': !matrixId || matrixId == 0 ? 'undefined' : matrixId
                    }, 'ProductClick', 'Success');

                    HSN.DataLayer.helpers.metricEvent(null, 'RE:grid', 'productclick', 'NA');
                }

                window.location = url;
            }
        }).on('click', '.item .preview', function (e) {
            e.stopPropagation();

            var data = $(this).closest('.item').data();
            var id = data['productId'];
            var matrixId = data['matrixId'];

            scope.application.GetProductPreviewOffCanvas().Show(id);

            HSN.DataLayer.helpers.hsnEvent({
                'product_variant_id': !matrixId || matrixId == 0 ? id : matrixId,
                'product_position': getCardPosition(id)
            }, 'ProductClick', 'Success');
            return false;
        }).on('click', '.item .quick-view', function (e) {
            e.stopPropagation();
            $('.quickview-container').hide();
            var position = $(this).closest('.item').position();
            var data = $(this).closest('.item').data();
            var id = data['productId'];
            var container = $('.quickview-container.' + id);
            container.css('top', position.top - 160).css('left', position.left - 150);
            $(container).show();
        }).on('mouseleave', '.item, .quickview-container', function (e) {
            $('.quickview-container').hide();
        }).on('click', '.tall-product-item .video a, .product-item .video a', function (e) {
            e.stopPropagation();
            e.preventDefault();

            var imageContainer = $(this).parent('.video').siblings('.info').find('.image');
            imageContainer.data('video-playing', true);
            var carousel = $('ul', imageContainer).data("carousel");
            if (carousel) {
                carousel.toggleAutoScroll(false);
            }

            var button = $(this);
            var parent;
            var videoPlayer;
            //seperate tall grid from normal grid:
            if ($(this).parents('.tall-product-item').length > 0) {
                parent = $(this).parents('.tall-product-item');
                videoPlayer = parent.find('.grid-video-player-tall');
            } else {
                parent = $(this).parents('.product-item');
                videoPlayer = parent.find('.grid-video-player');
            }

            var image = parent.find('.image').find('img');

            var videoData = {};
            videoData.w = button.data('w');
            videoData.h = button.data('h');
            videoData.httpUrl = button.attr('href');
            videoData.iosUrl = button.attr('href');

            videoData.analyticCat = button.data('analyticCat');
            videoData.analyticName = button.data('analyticName');
            videoData.application = scope.application;

            //playover overrides:
            videoData.overrides = {
                rules: {
                    android: {
                        regexp: 'Android'
                    }
                },

                media: {
                    title: videoData.analyticName,
                    source: [{ src: videoData.httpUrl, type: 'video/mp4' }]
                },
                autoplay: true,
                controls: {
                    mode: 'none'
                },
                captioning: {
                    enabled: true
                }
            };

            //create the player and listen to ready and ended events:
            var video = new Video(videoData, videoPlayer.attr('id'), function () {
                var player = video.getPlayer();
                // ReSharper disable once Html.EventNotResolved
                player.addEventListener('ready', function () {
                    video.controls('none');
                });

                // ReSharper disable once Html.EventNotResolved
                player.addEventListener('ended', function () {
                    videoPlayer.hide();
                    video.stop();
                    image.show();
                    button.show();
                });

                //show video, hide other elements:
                videoPlayer.show();
                image.hide();
                button.hide();
            });

            return false;
        }).on('click', '.product-item .swatches a, .list-product-item .swatches a', function (e) {
            e.preventDefault();

            var a = $(this);
            var alternates = a.data('alternates');
            $('.image', a.closest('.item')).html($('<img>', { src: alternates[0] }));

            return false;
        }).on('keydown', 'li.product-container.slick-slide', function (e) {
            if (e.key === 'Enter') {
                var li = $(this);

                e.preventDefault();
                e.stopPropagation();

                var link = li.find('a');
                if (link.length > 0) {
                    window.location.href = link.attr('href');
                }
            }
        });

        var listItems = [];
        $('body').on('keyup focus', 'li.product-container.slick-slide', function (e) {
            if (listItems.length === 0) {
                listItems = $('li.product-container.slick-slide');

                listItems.each(function () {
                    $(this).children().on('keyup focus', function (e) {
                        onLIFocusAndKeyup(e);
                    });
                });
            }

            onLIFocusAndKeyup(e);
        });

        var onLIFocusAndKeyup = function onLIFocusAndKeyup(e) {
            if (e.type === 'focus' || e.key === 'Tab') {
                var target = $(e.target);
                if (!target.is('li.product-container.slick-slide')) {
                    target = target.parents('li.product-container.slick-slide');
                }

                target.find('a').attr({
                    'tabindex': '-1'
                });
                target.find('input').attr({
                    'tabindex': '-1'
                });
            }
        };

        var preventMouseover = false;

        this.$container.on('touchstart', function (e) {
            preventMouseover = true;
        }).on('mouseenter', '.product-item .image, .list-product-item .image', function () {
            if (preventMouseover) return;

            var img = $(this).find('img');
            var alternates = img.data('alternates');
            var index = 0;
            var swapper = function swapper() {
                // Loop back around to the beginning.
                if (alternates === undefined) {
                    return;
                }
                if (index > alternates.length - 1) {
                    index = 0;
                }

                var currentImg = alternates[index];
                if (currentImg !== alternates[index++]) {
                    img.attr('src', alternates[index++]);
                    scope.alternatesTimeout = setTimeout(swapper, 1000);
                }
            };
            swapper();
        }).on('mouseleave', '.product-item .image, .list-product-item .image', function () {
            if (preventMouseover) return;

            if (null !== scope.alternatesTimeout) {
                clearTimeout(scope.alternatesTimeout);
                scope.alternatesTimeout = null;
            }
            var img = $(this).find('img');
            var alternates = img.data('alternates');
            if (alternates === undefined) {
                return;
            }
            img.attr('src', alternates[0]);
        }).on('mouseenter', '.product-item .info:not(.product-ensemble), .list-product-item .info:not(.product-ensemble)', function () {
            if (preventMouseover) return;

            // Move our preview button into this product card.
            $(this).append(getPreviewElement());
        }).on('mouseleave', '.product-item .info:not(.product-ensemble), .list-product-item .info:not(.product-ensemble)', function () {
            if (preventMouseover) return;

            // Remove our preview button from this product card, but keep it around for future use.
            getPreviewElement().detach();
        }).on('mouseenter', '.product-item .info .video', function () {
            if (preventMouseover) return;

            getPreviewElement().detach();
        }).on('mouseleave', '.product-item .info .video', function () {
            if (preventMouseover) return;

            $(this).closest('.info').append(getPreviewElement());
        }).on('mouseenter', '.product-item .image, .list-product-item .image, .tall-product-item .image', function (e) {
            if (preventMouseover) return;

            var cur = $(e.currentTarget);
            var carousel = $('ul', cur);
            var imgs = $('img', cur);

            if (cur.data('video-playing')) {
                return;
            }

            if (imgs.first().attr('src') === imgs.next().attr('src')) {
                altSameImages = true;
            }

            cur.addClass('new-alt hovered');

            if (!carousel.data('hsn-carousel') && imgs.length > 1) {
                new HSN.Widget.AltImageCarousel({
                    application: scope.application,
                    container: cur,
                    preloadFirstImage: true
                });
            }
        });

        /* Playing Product Videos */
        this.application.Events.On(HSN.Application.EVENT.VIDEO_COMPLETE, function (videoGridObj) {
            var currentObj = videoGridObj.parents();

            currentObj.find('.video-player').hide().children().remove();
            currentObj.find('.play').show();
            currentObj.find('.tall-product-item .image img, .product-item .image img').show();
        });
    };

    var constructor = function constructor(config) {
        var scope = this;
        /* Instance specific properties go here */
        this.application = config.application;
        this.$container = $(config.container);
        this.alternatesTimeout = null;

        bindEvents.call(this);

        // This abomination supports keyboard revealing/initializing the alt carousel when inside a card

        var cards = scope.$container.find('.product-item, .list-product-item, .tall-product-item');
        cards.each(function (i, el) {
            var curCard = $(el);
            var image = curCard.find('.image');
            if (image.length) {
                curCard.one('focusin', function () {
                    image.addClass('new-alt hovered');
                    var carousel = image.find('ul');
                    var imgs = carousel.find('img');
                    if (!carousel.data('hsn-carousel') && imgs.length > 1) {
                        new HSN.Widget.AltImageCarousel({
                            application: scope.application,
                            container: image,
                            preloadFirstImage: true
                        });
                    }
                }).on('focusout', function () {
                    setTimeout(function () {
                        if (!curCard.has(':focus').length) {
                            image.removeClass('hovered');
                        }
                    }, 100);
                }).on('focusin', function () {
                    image.addClass('hovered');
                }).on('mouseenter', function () {
                    image.addClass('hovered');
                }).on('mouseleave', function () {
                    image.removeClass('hovered');
                });
            }
        });
    };

    constructor.prototype = {
        constructor: constructor,
        refresh: function refresh() {
            if (!Modernizr.touchevents) {
                HSN.Tooltip(this.$container.find('[data-tooltip]'));
            }
        }
    };

    return constructor;
}();

/***/ }),

/***/ "vsRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("l/Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_slimscroll_js__ = __webpack_require__("R3LS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_slimscroll_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_LIBS_jquery_slimscroll_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_HSNDIR_Flyout_js__ = __webpack_require__("a4iX");

var $ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;


// define EVENTs


HSN.Breadbox = function (config) {
    this._container = $('#breadbox');

    if (!Modernizr.touchevents) {
        HSN.Tooltip(this._container.find("[data-tooltip]"));
    }

    var brandsContainer = this._container.find('.brands');

    this._brandsFlyout = new HSN.Flyout({
        trigger: brandsContainer,
        triggerEvent: 1,
        flyout: this._container.find('.brands .flyout'),
        closeClass: 'ir'
    });

    var brandsFlyoutIndicator = $('<div class="indicator ir"></div>');
    this._brandsFlyout.Flyout.append(brandsFlyoutIndicator);

    this._brandsFlyout.Events.On(HSN.Flyout.EVENT.BEFORE_OPEN, function (flyout) {
        var flyoutOuterHeight = flyout.Flyout.outerHeight();
        var brandsContainerTopOffset = brandsContainer.offset().top;
        var windowScrollTop = $(window).scrollTop();
        var topGap = brandsContainerTopOffset - windowScrollTop;

        var newPosition = flyoutOuterHeight / 2 * -1;

        if (newPosition < topGap * -1) {
            newPosition = topGap * -1;
        } else {
            var bottomGap = $(window).height() + windowScrollTop - (brandsContainer.outerHeight() + brandsContainerTopOffset);
            if (newPosition + flyoutOuterHeight > bottomGap) {
                newPosition = (flyoutOuterHeight - flyout.Trigger.outerHeight() - bottomGap) * -1;
            }
        }

        flyout.Flyout.css({
            top: newPosition
        });

        brandsFlyoutIndicator.css({
            top: newPosition * -1 - 3
        });

        //ADA Code
        var activeTab = $('li.active');
        if (activeTab.length) {
            activeTab[0].children[0].focus();
        }
        $('.flyout').attr('aria-hidden', 'false');
        $('.flyout-trigger').attr('aria-expanded', 'true');

        // This silliness is unfortunately needed to force CSS3Pie to reposition the shim element to the new position.
        flyout.Flyout.removeClass('flyout').addClass('flyout');
    }, this);

    this._brandsFlyout.Events.On(HSN.Flyout.EVENT.BEFORE_CLOSE, function () {
        var flyoutDiv = $('#breadboxFlyout');
        flyoutDiv.attr('aria-hidden', 'true');
        $('.flyout-trigger').focus();
        $('.flyout-trigger').attr('aria-expanded', 'false');
    }, this);
    //this._application.FlyoutManager.Add(this._brandsFlyout);

    new HSN.TabPanel(this._container.find('.flyout .tabs'), '.tab-items > li > a');

    new HSN.Carousel({
        container: this._container.find('.right ul.product-list'),
        touch: Modernizr.touchevents
    });

    var isTablet = HSN.Instance().DeviceInformation.IsTablet;
    $('.lnav .scroll').filter(function (i, e) {
        // get groups that have a scroll bar; do +1 for IE, otherwise it thinks all sections have a scrollbar
        return $(e).get(0).scrollHeight > $(e).get(0).clientHeight + 1;
    }).slimScroll({
        alwaysVisible: isTablet,
        color: '#999',
        railColor: '#f2f2f2',
        height: 'none',
        size: '11px',
        wheelStep: isTablet ? 40 : 3,
        opacity: 1,
        railOpacity: 1,
        railVisible: true,
        disableFadeOut: true
    });
    if (!isTablet) $('.lnav .slimScrollBar').hide();
};
HSN.Breadbox.prototype = {};

/***/ })

},["ad5Z"]);


// WEBPACK FOOTER //
// grid.9f9af221849519461c5e.js